/*******************************************************************************************************
 **                                                                                                    **
 **                                             VARIABLES                                              **
 **                                                                                                    **
 *******************************************************************************************************/
const decodeMaxAttempts = 3;

let globalLocale = "en";

let attemptedVinsInGarage = [];
let attemptedVinsVinVerification = [];
let attemptedVinsOEM = [];
let attemptedOEMVins = [];
let attemptedDecodedVins = [];
let attemptedDecodedLicensePlates = [];

let productPageTroublesomeReferences = {};

let finalVinVerificationSubmissionVin = "";
let garageFirstVehicleData = "";
let themeName = "";
let autoSelectedColor = "";
let autoSelectedOption = "";
let storedDecodedVin = "";
let firstVehicleColor = "";
let decodedPaintedOptionPainted = "";
let decodedPaintedOptionPrice = "";
let licenseOptionMsg = "";
let vinOptionMsg = "";
let vinWord = "";
let licensePlateWord = "";
let chromeDataMakesGlobal = "";
let bumperMakesGlobal = "";
let troublesomeMakesGlobal = "";
let excludedMakesGlobal = "";
let licenseGarageLatest = "";
let matchPaintByVinTranslationKey = "";

let garageVinSubmissionBool = false;
let successfulVinVerificationVin = false;
let successfulVinDecoding = false;
let alreadyLogged = false;
let garageToCollections = false;
let decodedVINHasAvailableStock = false;
let autoSelectedBanned = false;
let isCurrentVehicleTroublesome = false;
let storedPaintOptionIsDTM = false;
let matchingPaintByVinVisible = false;

// Global variables for mismatch tracking
let isMismatch = false;
let mismatchDifferences = {}; // e.g., { year: {user: '2020', decoded: '2021'}, ... }
let decodedVehicleData = {};
let vinAttachedToOrderTranslationPayload = {};

// unresolved-mismatch flags
window.MISMATCH_JSON_LOOKUP_MISS = false; // JSON didn’t have a mapping
window.MISMATCH_UNRESOLVED = false; // could not resolve decoded Y/M/M to EasySearch

const vinInputLibrary = document.querySelector("#vin-textbox");
const vinTextboxContainer = document.getElementById("vin-textbox-container");
const paintOptionGroup = document.getElementById("paint-options-group");
const storedDecodedPaintCodeMsgGlobal = document.querySelector(
	".stored-decoded-paint-msg"
);
const selectCodeOptionLabel = document.getElementById(
	"paint-code-select-code-option"
);
const licenseOptionLabel = document.getElementById("paint-code-license-option");
const storedOptionLabel = document.getElementById("paint-code-stored-option");
const failSafeSelectCodeOptionLabel = document.querySelector(
	".select-code-fail-safe"
);
const checkboxStoredCodeText = document.querySelector(".checkbox-stored-code");

/*******************************************************************************************************
 **                                                                                                    **
 **                                           GARAGE LOGIC                                             **
 **                                                                                                    **
 *******************************************************************************************************/
/**
 * Syncs custom easysearch buttons to match the enabled state of the native easysearch search buttons.
 * Handles dynamic DOM changes, multiple holders, and mobile/desktop variants.
 */
function syncCustomEasySearchButtons() {
	const holders = document.querySelectorAll(".easysearch-holder");
	holders.forEach(function (holder) {
		// Find or create the custom button
		let btn = holder.querySelector(".custom-easysearch-ymm-btn");
		if (!btn) {
			const refBtn = document.getElementById("license-to-vin-btn");
			btn = document.createElement("button");
			btn.type = "button";
			btn.id = "custom-easysearch-ymm-btn-id";
			btn.className = "custom-easysearch-ymm-btn";
			btn.innerHTML = refBtn ? refBtn.innerHTML : "Search";
			btn.disabled = true;
			holder.appendChild(btn);
		}
		btn.onclick = async function () {
			if (btn.disabled) return;
			const year = document.getElementById("easysearch_field_4973");
			const make = document.getElementById("easysearch_field_4974");
			const model = document.getElementById("easysearch_field_4975");
			const submodel = document.getElementById("easysearch_field_28136");
			const engine = document.getElementById("easysearch_field_28137");

			let newVin = null;
			let newPaintCode = null;
			let newDecodedByBumper = null;
			let newLastCollectionImage = null;

			if (window.editCarState && window.editCarState.open) {
				const terms = getSearchTerms();
				const index = terms.findIndex(
					(t) => (t.ymm || "").trim() === window.editCarState.ymm.trim()
				);
				newVin = terms[index].vin;
				newPaintCode = terms[index].paintCode;
				newDecodedByBumper = terms[index].decodedByBumper;
				newLastCollectionImage = terms[index].lastCollectionImage;

				updateSearchTerms(
					window.editCarState.ymm,
					year.value,
					make.value,
					model.value,
					submodel.value,
					engine.value,
					newVin,
					newPaintCode,
					newDecodedByBumper,
					newLastCollectionImage
				);
			} else {
				// Adding new vehicle
				const ymm = [
					year.value,
					make.value,
					model.value,
					submodel.value,
					engine.value,
				]
					.filter(Boolean)
					.join(" ");

				updateSearchTerms(
					ymm,
					year.value,
					make.value,
					model.value,
					submodel.value,
					engine.value,
					null,
					null,
					null,
					null
				);
			}

			// Fire-and-forget: log in background without blocking UI
			logGarageEventToSheets("dropdown", {});

			updateEasysearchLocalStorageOrNavigate(
				year ?? null,
				make ?? null,
				model ?? null,
				submodel ?? null,
				engine ?? null,
				newVin,
				newPaintCode,
				newDecodedByBumper,
				newLastCollectionImage
			);
			//after this, if it's in product page, need to reset all the selections
			const successEl = document.querySelector(
				".easysearch-fitment-icon-success"
			);

			// if successEl -> it's success fitment
			// if failEl + successEL -> it's fail fitment
			if (successEl) {
				const qualityTypeSelect = document.getElementById(
					"quality-type-select"
				);
				const aspirationQuestionsContainer = document.querySelector(
					".required-questions-container"
				);
				const paintOptionsCheckbox = document.querySelector(
					".paint-options-checkbox-group"
				);
				const checkboxUseStoredCode = document.getElementById(
					"checkbox-paint-code-local-storage"
				);

				resetAllHeaderColors(true);

				if (aspirationQuestionsContainer) {
					disableFitmentSelect();
				}

				if (qualityTypeSelect) {
					disableQualityTypeSelect();
					disableQualityDescriptionBtn();
				}

				if (paintOptionsCheckbox) {
					const vinElements = getVisibleVinDecoderElements();
					if (vinElements) {
						if (vinElements.input) {
							vinElements.input.value = "";
						}
					}
					if (checkboxUseStoredCode.checked || checkboxUseStoredCode) {
						resetPaintOptionRadioBtns();
						const storedDecodedPaintCodeMsgLibrary = document.querySelector(
							".stored-decoded-paint-msg"
						);
						storedDecodedPaintCodeMsgLibrary.style.display = "none";
					}
					clearPaintOptionRadioBtns();
					disablePaintOptionRadioBtns();
					clearCombinedVariantSelect();
					disablehowToFindPaintCodeBtn();
					hideColorPreviewContainer();
				}

				disableCombinedVariantSelect();
				disableVinVerificationBtns();
				clearVinVerificationRadioButtons();
				disableGetPaintCodeUsingVin();
				disableSelectVinVariantBtn();
				hideNotCompatibleMsg();
				disableFitmentSelect();
				disableAddToCartButton();
				handleInsertLocalStoragePaintOption();
			}
		};

		// Always re-query anchors in this holder!
		const anchors = holder.querySelectorAll("a.easysearch-btn-search");
		let isEnabled = false;
		anchors.forEach((anchor) => {
			// Attach attribute observer if not already attached
			if (!anchor._customObserverAttached) {
				const anchorObserver = new MutationObserver(() => {
					syncCustomEasySearchButtons();
				});
				anchorObserver.observe(anchor, { attributes: true });
				anchor._customObserverAttached = true;
			}

			if (
				!anchor.hasAttribute("disabled") &&
				anchor.getAttribute("href") &&
				!anchor.getAttribute("href").includes("javascript:void(0)")
			) {
				isEnabled = true;
			}
		});
		btn.disabled = !isEnabled;
	});
}

// Run on easysearch event
document.addEventListener("easysearch_rendered", syncCustomEasySearchButtons);

// Fallback: if event already fired before listener registered
if (window.easysearchWasRendered) syncCustomEasySearchButtons();

// Use MutationObserver to watch for holder changes!
const easysearchContainer = document.getElementById("easysearch-container");
if (easysearchContainer) {
	const containerObserver = new MutationObserver(() => {
		syncCustomEasySearchButtons();
	});
	containerObserver.observe(easysearchContainer, {
		childList: true,
		subtree: true,
	});
}

// This function is in place because old versions of the garage where in different formats.
// To keep things consistent, this function will update a person's garage to the new format
// if they still have the old format
function normalizeSearchTerm(entry) {
	// Migration for string entries
	if (typeof entry === "string") {
		return {
			ymm: entry,
			vin: null,
			paintCode: null,
			year: null,
			make: null,
			model: null,
			submodel: null,
			engine: null,
			state: null,
			plate: null,
			decodedByBumper: null,
			lastCollectionImage: null,
		};
	}

	// Migration for object entries with ymm as object
	if (entry && typeof entry.ymm === "object" && entry.ymm !== null) {
		entry = {
			ymm: entry.ymm.ymm || null,
			vin: entry.ymm.vin || null,
			paintCode: entry.ymm.paintCode || null,
			year: entry.ymm.year || null,
			make: entry.ymm.make || null,
			model: entry.ymm.model || null,
			submodel: entry.ymm.submodel || null,
			engine: entry.ymm.engine || null,
			state: entry.ymm.state || null,
			plate: entry.ymm.plate || null,
			decodedByBumper: entry.ymm.decodedByBumper || null,
			lastCollectionImage: entry.ymm.lastCollectionImage,
		};
	}

	return {
		ymm: entry.ymm,
		vin: entry.vin || null,
		paintCode: entry.paintCode || null,
		year: entry.year || null,
		make: entry.make || null,
		model: entry.model || null,
		submodel: entry.submodel || null,
		engine: entry.engine || null,
		state: entry.state || null,
		plate: entry.plate || null,
		decodedByBumper: entry.decodedByBumper || null,
		lastCollectionImage: entry.lastCollectionImage || null,
	};
}

function getSearchTerms() {
	let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
	terms = terms.map(normalizeSearchTerm);

	// Save back (migration)
	// We do this because a user may have an outdated searchTerms format -- therefore it must be updated with normalizeSearchTerm
	// Once normalized we rewrite it to localstorage to ensure it is always to most up to date format
	localStorage.setItem("searchTerms", JSON.stringify(terms));
	return terms;
}

function removeVINsLessThan17Chars() {
	let terms = getSearchTerms();
	let shouldRefresh = false;
	terms = terms.map((term) => {
		if (
			term.vin === null ||
			(typeof term.vin === "string" && term.vin.length === 17)
		) {
			return term;
		} else {
			shouldRefresh = true;
			return { ...term, vin: null };
		}
	});
	setSearchTerms(terms, 1);
	if (shouldRefresh) {
		let refreshCount = parseInt(
			localStorage.getItem("vinRefreshCount") || "0",
			10
		);
		if (refreshCount < 3) {
			localStorage.setItem("vinRefreshCount", refreshCount + 1);
			window.location.reload();
		} else {
			localStorage.removeItem("vinRefreshCount");
		}
	}
}

function setSearchTerms(terms, location) {
	const uniqueTerms = [];
	const seen = new Set();
	const currentPage = window.location.href || "";
	for (const term of terms) {
		const normalized = normalizeSearchTerm(term);
		const trimmedYmm = normalized.ymm.trim();
		if (!seen.has(trimmedYmm)) {
			uniqueTerms.push({
				...normalized,
				ymm: trimmedYmm,
				currentPage: currentPage,
				lastCollectionImage: "",
			});
			seen.add(trimmedYmm);
		}
	}
	localStorage.setItem("searchTerms", JSON.stringify(uniqueTerms));
}

// --- Always adds a new vehicle and moves to front ---
function moveVehicleToFront(vehicleData) {
	let currentSearchTerms = getSearchTerms();
	// vehicleData can be a string (ymm) or an object
	let ymm = typeof vehicleData === "string" ? vehicleData : vehicleData.ymm;

	let state = typeof vehicleData === "string" ? null : vehicleData.state;
	let plate = typeof vehicleData === "string" ? null : vehicleData.plate;
	let vin = typeof vehicleData === "string" ? null : vehicleData.vin;

	// Find index where ymm matches exactly, or is contained in obj.ymm, or obj.ymm is contained in ymm
	let vehicleIndex = currentSearchTerms.findIndex(
		(obj) => obj.ymm === ymm

		// (obj) => obj.ymm === ymm || obj.ymm.includes(ymm) || ymm.includes(obj.ymm)
	);
	let vehicleObj = normalizeSearchTerm(vehicleData);
	if (vehicleIndex > -1) {
		vehicleObj = currentSearchTerms.splice(vehicleIndex, 1)[0];
		// If either ymm contains the other, set ymm to the longer one
		if (vehicleObj.ymm !== ymm) {
			if (vehicleObj.ymm.length < ymm.length) {
				vehicleObj.ymm = ymm;
			}
		}
	} else {
		vehicleObj = normalizeSearchTerm(vehicleData);
	}

	// If currentSearchTerms.state does not exist add it
	if (state) {
		vehicleObj.state = state;
	}

	if (plate) {
		vehicleObj.plate = plate;
	}

	if (vin) {
		vehicleObj.vin = vin;
	}
	currentSearchTerms.unshift(vehicleObj);
	if (currentSearchTerms.length > 5) currentSearchTerms.pop();
	setSearchTerms(currentSearchTerms, 2);
	return currentSearchTerms;
}

async function setSelectValueWhenReady(selectId, value, timeout = 3000) {
	const select = document.getElementById(selectId);
	let newValue = "";
	if (!select) return newValue;

	const start = Date.now();
	return new Promise((resolve) => {
		function trySet() {
			const match = Array.from(select.options).find(
				(opt) => opt.value.toLowerCase().trim() === value.toLowerCase().trim()
			);
			if (match) {
				select.value = match.value;
				newValue = match.value;
				select.dispatchEvent(new Event("change", { bubbles: true }));
				resolve(newValue);
			} else if (Date.now() - start > timeout) {
				resolve(newValue); // Timed out, value not set
			} else {
				setTimeout(trySet, 50);
			}
		}
		trySet();
	});
}

function setFitmentObject(obj) {
	localStorage.setItem("easysearch-preselect-fitment", JSON.stringify(obj));
	localStorage.setItem("easysearch-preselect", JSON.stringify(obj));
}

function toStringValue(f) {
	if (f == null) return "";
	if (typeof f === "string" || typeof f === "number") return String(f).trim();
	if (typeof f.value === "string" || typeof f.value === "number")
		return String(f.value).trim();
	return "";
}

function updateEasysearchLocalStorageOrNavigate(
	year,
	make,
	model,
	submodel,
	engine,
	vin,
	paintCode,
	decodedByBumper,
	lastCollectionImage
) {
	let anchor = null;
	const holder = document.querySelector(".easysearch-holder");
	const actionsHolder = holder?.querySelector(".easysearch-actions-holder");
	if (actionsHolder) {
		const btnHolder = actionsHolder.querySelector(".easysearch-btn-holder");
		if (btnHolder) {
			anchor = btnHolder.querySelector("a");
		}
	}

	const yearVal = toStringValue(year);
	const makeVal = toStringValue(make);
	const modelVal = toStringValue(model);
	const submodelVal = toStringValue(submodel);
	const engineVal = toStringValue(engine);
	const vinVal = toStringValue(vin);
	const paintCodeVal = toStringValue(paintCode);
	const fields = [yearVal, makeVal, modelVal, submodelVal, engineVal];

	const ymm = [yearVal, makeVal, modelVal, submodelVal, engineVal]
		.filter(Boolean)
		.join(" ");

	const isProductPage = window.location.pathname.includes("/products/");
	updateSearchTerms(
		ymm,
		yearVal,
		makeVal,
		modelVal,
		submodelVal,
		engineVal,
		vinVal,
		paintCodeVal,
		decodedByBumper,
		lastCollectionImage
	);
	if (isProductPage) {
		updateProductPageFitment(ymm, fields, anchor);
		window.fbtRefresh();
		// window.location.reload();
	} else {
		// window.location.href = anchor?.href;
		const url = new URL(anchor.href);
		window.location.href = url.pathname + url.search + url.hash;
	}
}

function updateProductPageFitment(ymm, fields, anchor) {
	let fitmentValue = "";
	const easySearchBtnSearch = document.querySelector(".easysearch-btn-search");
	let expires = Date.now() + 365 * 24 * 60 * 60 * 1000;
	// Build fitmentValue from the longest non-empty prefix of fields
	let prefix = [];
	for (let f of fields) {
		if (!f || f === "") {
			break;
		}
		prefix.push(f);
	}
	if (prefix.length === 0) {
		console.warn("Aborting fitmentValue creation: all fields are empty.");
		return;
	}
	fitmentValue = prefix
		.map((f) => f + "easysearch-preselect-delimiter")
		.join("");
	const fitmentObject = {
		value: fitmentValue,
		expires: expires.toString(),
	};
	setFitmentObject(fitmentObject);

	// Save current search parameters to localStorage or backend
	easysearch.saveSearchParams(easySearchBtnSearch);
	easysearch.addPropertyToProductForm();
	// Get the fitment widget element and the URL to load fitment results
	const fitWidget = document.querySelector(".easysearch-fitment-widget");
	const fitmentUrl = anchor?.href;

	// Function to trigger the fitment widget toggle after EasySearch is ready
	function triggerFitmentWidget() {
		if (
			window.easysearch &&
			typeof easysearch.fitmentToggleWidget === "function" &&
			fitWidget &&
			fitmentUrl
		) {
			easysearch.fitmentToggleWidget(fitWidget, fitmentUrl);
			document.removeEventListener(
				"easysearch_init_native_search_page",
				triggerFitmentWidget
			);
		}
	}

	document.addEventListener(
		"easysearch_init_native_search_page",
		triggerFitmentWidget
	);

	if (
		window.easysearch &&
		typeof easysearch.fitmentToggleWidget === "function"
	) {
		easysearch.fitmentToggleWidget(fitWidget, fitmentUrl);
	}

	toggleGaragePopup();
	const hiddenEasysearchEl = document.querySelector(
		".easysearch-fitment-search-widget"
	);
	const failOrSuccessEasysearchEl = document.querySelector(
		".easysearch-fitment-holder"
	);
	if (
		hiddenEasysearchEl &&
		!hiddenEasysearchEl.classList.contains("easysearch-hidden")
	) {
		hiddenEasysearchEl.classList.add("easysearch-hidden");
	}
	if (
		failOrSuccessEasysearchEl &&
		failOrSuccessEasysearchEl.classList.contains("easysearch-hidden")
	) {
		failOrSuccessEasysearchEl.classList.remove("easysearch-hidden");
	}
}

/**
 *
 * @param {*} ymm
 * @param {*} yearVal
 * @param {*} makeVal
 * @param {*} modelVal
 * @param {*} submodelVal
 * @param {*} engineVal
 * @param {*} vinVal
 * @param {*} paintCodeVal
 * @param {*} decodedByBumper
 * @param {*} lastCollectionImage
 * Allows for editing a vehicle in place
 * SHOULD NOT add any new vehicle
 * Moves vehicle to front
 */
function updateSearchTerms(
	ymm,
	yearVal,
	makeVal,
	modelVal,
	submodelVal,
	engineVal,
	vinVal,
	paintCodeVal,
	decodedByBumper,
	lastCollectionImage
) {
	// Custom deduplication and update logic
	let searchTerms = getSearchTerms();

	let foundIdx = searchTerms.findIndex((term) =>
		// only check if can find a car that match year/make/model
		// if so, we only update, dont add a new car
		//term.year === yearVal && term.make === makeVal && term.model === modelVal
		{
			return term.ymm.trim() === ymm.trim();
		}
	);

	// Found a match car on ymm
	if (ymm && foundIdx > -1) {
		let updated = false;
		let formattedYmm = "";
		// debugger;

		// reference of existing car
		let car = searchTerms[foundIdx];

		// Update year if incoming is more specific or different
		if (yearVal && (!car.year || car.year !== yearVal)) {
			car.year = yearVal;
			car.submodel = null;
			car.engine = null;
			updated = true;
		}

		// Update make if incoming is more specific or different
		if (makeVal && (!car.make || car.make !== makeVal)) {
			car.make = makeVal;
			car.submodel = null;
			car.engine = null;
			updated = true;
		}

		// Update model if incoming is more specific or different
		if (modelVal && (!car.model || car.model !== modelVal)) {
			car.model = modelVal;
			car.submodel = null;
			car.engine = null;
			updated = true;
		}

		// Update submodel if incoming is more specific or different
		if (submodelVal && (!car.submodel || car.submodel !== submodelVal)) {
			car.submodel = submodelVal;
			car.engine = null;
			updated = true;
		}
		// Update engine if incoming is more specific
		if (engineVal && (!car.engine || car.engine !== engineVal)) {
			car.engine = engineVal;
			updated = true;
		}
		// Update VIN if it doesn't already exist
		if (vinVal && !car.vin) {
			car.vin = vinVal;
			updated = true;
		}
		// Update paintcode if it doesn't already exist
		if (paintCodeVal && !car.paintCode) {
			car.paintCode = paintCodeVal;
			// Update the decodedByBumper here too
			searchTerms[foundIdx].decodedByBumper = decodedByBumper;
			updated = true;
		}

		if (submodelVal && engineVal) {
			formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""} ${
				engineVal || ""
			}`;
		} else if (submodelVal && !engineVal) {
			formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""}`;
		} else {
			formattedYmm = `${yearVal} ${makeVal} ${modelVal}`;
		}
		car.ymm = formattedYmm;

		// Always move this car to the front, even if nothing was updated
		if (updated || true) {
			const [movedCar] = searchTerms.splice(foundIdx, 1);
			searchTerms.unshift(car);
		}
		// GarageUI.buildVehicleListHTML(searchTerms);

		setSearchTerms(searchTerms, 3);
		// This is a new entry (did not find a match in garage)
	} else if (ymm && foundIdx === -1) {
		// debugger;
		// No match on year, make, model, so add new
		const newTerm = normalizeSearchTerm({
			ymm,
			vin: vinVal,
			paintCode: paintCodeVal,
			year: yearVal,
			make: makeVal,
			model: modelVal,
			submodel: submodelVal,
			engine: engineVal,
			decodedByBumper: decodedByBumper,
			lastCollectionImage: lastCollectionImage,
		});
		searchTerms.unshift(newTerm);
		// use splice to keep the limit
		if (searchTerms.length > 5) searchTerms.splice(5);
		setSearchTerms(searchTerms, 4);
	}
}

function refactorModels(make, model) {
	let refactoredModel = model;
	let capMake = make.toUpperCase();
	let capModel = model.toUpperCase();
	// Special cases:

	// Chromedata returns the word mazda along with the model type.
	// e.g. Mazda3 instead of 3
	if (refactoredModel.includes("Mazda")) {
		// For the case where it is a hatchback, will look like Mazda3 Hatchback, pull the first word
		refactoredModel = refactoredModel.split(" ")[0];
		refactoredModel = refactoredModel.replace("Mazda", "");
	}

	// Chromedata can return the submodel along with subaru submodels.
	// e.g. WRX STI instead of WRX
	if (capMake === "SUBARU" && capModel.includes("WRX")) {
		// Just take the first word in this case
		refactoredModel = refactoredModel.split(" ")[0];
	}

	if (capMake === "LEXUS") {
		refactoredModel = refactoredModel.replace(" ", "");
	}

	return refactoredModel;
}

async function updateGarageAndNavigate(
	year,
	make,
	model,
	submodel,
	engine,
	vin,
	paintCode,
	state,
	plate,
	decodedByBumper,
	lastCollectionImage
) {
	const refactoredModel = refactorModels(make, model);

	const yearVal = await setSelectValueWhenReady(
		"easysearch_field_4973",
		year || ""
	);
	const makeVal = await setSelectValueWhenReady(
		"easysearch_field_4974",
		make || ""
	);
	const modelVal = await setSelectValueWhenReady(
		"easysearch_field_4975",
		model || ""
	);
	const submodelVal = await setSelectValueWhenReady(
		"easysearch_field_28136",
		submodel || ""
	);
	const engineVal = await setSelectValueWhenReady(
		"easysearch_field_28137",
		engine || ""
	);

	let localPaintCode = null;

	if (!isCurrentVehicleTroublesome) {
		localPaintCode = paintCode;
	}

	if (yearVal === "" || makeVal === "" || modelVal === "") {
		return false;
	}

	let formattedYmm = "";
	if (submodelVal && engineVal) {
		formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""} ${
			engineVal || ""
		}`;
	} else if (submodelVal && !engineVal) {
		formattedYmm = `${yearVal} ${makeVal} ${modelVal} ${submodelVal || ""}`;
	} else {
		formattedYmm = `${yearVal} ${makeVal} ${modelVal}`;
	}

	// updateSearchTerms(
	// 	formattedYmm,
	// 	yearVal,
	// 	makeVal,
	// 	modelVal,
	// 	submodelVal,
	// 	engineVal,
	// 	vin,
	// 	localPaintCode,
	// 	decodedByBumper,
	// 	lastCollectionImage
	// );

	const updatedSearchTerms = moveVehicleToFront({
		ymm: formattedYmm,
		vin: vin || null,
		paintCode: localPaintCode || null,
		year: yearVal || null,
		make: makeVal || null,
		model: modelVal || null,
		submodel: submodelVal || null,
		engine: engineVal || null,
		state: state || null,
		plate: plate || null,
		decodedByBumper: decodedByBumper || null,
	});

	if (!window.location.pathname.includes("/products/")) {
		const btnHolder = document.querySelector(".easysearch-btn-holder");
		if (btnHolder) {
			const anchor = btnHolder.querySelector("a");
			if (anchor) {
				const url = new URL(anchor.href);
				if (anchor.href && !anchor.href.includes("javascript:void(0)")) {
					window.location.href = url.pathname + url.search + url.hash;
				}
			}
		}
	} else {
		updateEasysearchLocalStorageOrNavigate(
			yearVal,
			makeVal,
			modelVal,
			submodelVal,
			engineVal,
			vin,
			localPaintCode,
			decodedByBumper
		);
		// If on product page and paint option is available in local storage, update paint
		// options radio buttons
		firstVehicleColor = handleInsertLocalStoragePaintOption();
	}
	return true;
}

// Used for generating the correct filtered URL for non compatible vehicles
function updateGarageFirstVehicleData() {
	const vehicleDataContainer = document.querySelector(
		".vehicle-item-container.first-vehicle-item-container .vehicle-browse-catalog-container strong[data-vehicle]"
	);
	const notCompatibleBtnContainer = document.querySelector(
		".not-compatible-button"
	);
	if (vehicleDataContainer) {
		garageFirstVehicleData = vehicleDataContainer.getAttribute("data-vehicle");
	}
	if (!garageFirstVehicleData) {
		if (notCompatibleBtnContainer)
			notCompatibleBtnContainer.style.display = "none";
	} else {
		if (notCompatibleBtnContainer)
			notCompatibleBtnContainer.style.display = "block";
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

async function getIpAddress() {
	try {
		const response = await fetch("https://api.ipify.org?format=json");
		const data = await response.json();
		return data.ip; // Returns the client's public IP
	} catch (error) {
		console.error("Error fetching IP address:", error);
		return null;
	}
}

function setVinDecoderInputValue(storedVinMsg, vinInputBox, vinSubmitBtn) {
	const garageSearchTerms = getSearchTerms();
	if (
		garageSearchTerms &&
		garageSearchTerms[0] &&
		garageSearchTerms[0].vin &&
		!isMismatch
	) {
		const vin = garageSearchTerms[0].vin;
		const ymm = garageSearchTerms[0].ymm || "";
		if (storedVinMsg) {
			storedVinMsg.style.display = "block";
			if (ymm === "") {
				storedVinMsg.textContent = `Using VIN: ${vin}`;
			} else {
				storedVinMsg.textContent = `Using ${vin} for your ${ymm}`;
			}
			vinInputBox.value = vin;
			vinSubmitBtn.disabled = false;
		}
	}
}

function removeVinDecoderInputValue(storedVinMsg, vinInputBox, vinSubmitBtn) {
	const garageSearchTerms = getSearchTerms();
	if (
		garageSearchTerms &&
		garageSearchTerms[0] &&
		garageSearchTerms[0].vin &&
		!isMismatch
	) {
		if (storedVinMsg) {
			storedVinMsg.style.display = "none";
			storedVinMsg.textContent = "";
			vinInputBox.value = "";
			vinSubmitBtn.disabled = true;
		}
	}
}

/*
    functionLocation - 1 = Garage
    functionLocation - 2 = Vin Verification
*/
// Function to handle VIN change
function handleVinChange(event, functionLocation, errorMsg) {
	let activeWrapper;
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		activeWrapper = vinElements.wrapper;
	}
	let vinInput = event.target.value.toUpperCase();
	const filteredValue = vinInput.replace(
		/[IOQ\s:;()!@#$%^?'"&*\-_=+.`~<>{}\[\]|,\/\\]/gi,
		""
	);
	const truncatedValue = filteredValue.slice(0, 17);

	event.target.value = truncatedValue;

	if (functionLocation === 1) {
		if (attemptedVinsInGarage.length) {
			for (let i = 0; i < attemptedVinsInGarage.length; i++) {
				if (
					attemptedVinsInGarage[i].toUpperCase() ===
					truncatedValue.toUpperCase()
				) {
					document.querySelector(".errorMessageVIN").style.visibility =
						"visible";
					document.querySelector(".errorMessageVIN").innerHTML =
						"VIN already searched. Please try a different VIN";
					document.getElementById("vin-to-collection-btn").disabled = true;
					return;
				} else {
					document.querySelector(".errorMessageVIN").style.visibility =
						"hidden";
				}
			}
		}

		if (truncatedValue.length === 17) {
			document.getElementById("vin-to-collection-btn").disabled = false;
		} else {
			document.getElementById("vin-to-collection-btn").disabled = true;
		}

		if (vinInput !== filteredValue) {
			alert(errorMsg);
		}
	} else if (functionLocation === 2) {
		if (attemptedVinsVinVerification.length) {
			for (let i = 0; i < attemptedVinsVinVerification.length; i++) {
				if (
					attemptedVinsVinVerification[i].toUpperCase() ===
					truncatedValue.toUpperCase()
				) {
					let activeWrapper;
					if (vinElements) {
						activeWrapper = vinElements.wrapper;
					}
					const vinErrorMsgContainer = activeWrapper.querySelector(
						".vin-error-message-container"
					);
					vinErrorMsgContainer.style.display = "block";

					activeWrapper.querySelector(
						".vin-verification-submission-failed-message"
					).style.display = "block";
					activeWrapper.querySelector(
						".vin-verification-submission-failed-message"
					).innerHTML = "VIN already searched. Please try a different VIN";
					//document.getElementById('vin-to-collection-btn').disabled = true;

					document.querySelector(
						'.vin-decoder-submit-btn:not([style*="display: none"])'
					).disabled = true;
					return true;
				} else {
					activeWrapper.querySelector(
						".vin-verification-submission-failed-message"
					).style.display = "none";
				}
			}
		}

		if (truncatedValue.length === 17) {
			document.getElementById("vin-to-collection-btn").disabled = false;
		} else {
			document.getElementById("vin-to-collection-btn").disabled = true;
		}

		if (vinInput !== filteredValue) {
			alert(errorMsg);
		}
	} else if (functionLocation === 3) {
		if (attemptedDecodedVins.length) {
			for (let i = 0; i < attemptedDecodedVins.length; i++) {
				if (
					attemptedDecodedVins[i].toUpperCase() === truncatedValue.toUpperCase()
				) {
					let activeWrapper;
					if (vinElements) {
						activeWrapper = vinElements.wrapper;
					}
					const vinErrorMsgContainer = activeWrapper.querySelector(
						".vin-error-message-container"
					);
					vinErrorMsgContainer.style.display = "block";

					activeWrapper.querySelector(
						".vin-decoder-submission-failed-message"
					).style.display = "block";
					activeWrapper.querySelector(
						".vin-decoder-submission-failed-message"
					).innerHTML = "VIN already searched. Please try a different VIN";
					const addToCartBtn = document.querySelector(".add-to-cart");
					if (addToCartBtn) addToCartBtn.disabled = true;
					// document.getElementById('vin-to-collection-btn').disabled = true;
					return true;
				} else {
					activeWrapper.querySelector(
						".vin-decoder-submission-failed-message"
					).style.display = "none";
				}
			}
		}

		if (vinInput !== filteredValue) {
			alert(errorMsg);
		}
	}
}

function handleStateSelectChange(
	event,
	errorAlreadyAttempted,
	errorMessageSelector,
	buttonId,
	licenseInput,
	oRestrictedStates
) {
	const stateInput = event.target.value.toUpperCase();
	const licenseBtn = document.getElementById(buttonId);
	const errorMessageLicense = document.querySelector(errorMessageSelector);
	let licenseValue = document.getElementById(licenseInput).value;

	// If a user typed in their license before selected a state, and the state restricts "O"s, then we need to clean the license plate now
	// This is to avoid a situation where a user types in a license plate with "O"s, then selects a state that restricts "O"s, but the license plate still has "O"s in it
	if (licenseValue.length) {
		licenseValue = cleanLicensePlate(
			stateInput,
			licenseValue,
			oRestrictedStates
		);

		licenseGarageLatest = licenseValue;
		document.getElementById(licenseInput).value = licenseValue;
	}
	event.target.value = stateInput;
	if (
		attemptedDecodedLicensePlates.includes(
			stateInput + "-" + licenseGarageLatest
		)
	) {
		licenseBtn.disabled = true;
		errorMessageLicense.style.visibility = "visible";
		errorMessageLicense.innerHTML = errorAlreadyAttempted;
		return;
	}
	if (
		errorMessageLicense.style.visibility &&
		errorMessageLicense.style.visibility === "visible"
	)
		errorMessageLicense.style.visibility = "hidden";
	if (
		typeof licenseGarageLatest === "string" &&
		licenseGarageLatest.length > 0
	) {
		licenseBtn.disabled = false;
	} else {
		licenseBtn.disabled = true;
	}
}

function handleLicenseChange(
	event,
	functionLocation,
	errorMsg,
	errorAlreadyAttempted,
	stateDropdownClass,
	oRestrictedStates,
	id
) {
	let licenseInput = event.target.value.toUpperCase();
	const stateSelect = document.querySelector(stateDropdownClass);
	const state = stateSelect ? stateSelect.value : "";
	let sanitizedPlateInput = cleanLicensePlate(
		state,
		licenseInput,
		oRestrictedStates
	);

	event.target.value = sanitizedPlateInput;
	const licenseBtn = document.getElementById(id);
	const errorMessageLicense = document.querySelector(".errorMessageLicense");

	licenseGarageLatest = sanitizedPlateInput;
	if (
		attemptedDecodedLicensePlates.includes(state + "-" + sanitizedPlateInput)
	) {
		licenseBtn.disabled = true;
		errorMessageLicense.style.visibility = "visible";
		errorMessageLicense.innerHTML = errorAlreadyAttempted;
		return;
	}
	if (errorMessageLicense.style.visibility === "visible")
		errorMessageLicense.style.visibility = "hidden";
	if (state.length && sanitizedPlateInput.length > 0) {
		licenseBtn.disabled = false;
	} else {
		licenseBtn.disabled = true;
	}
}

/**
 * @param {*} vinInput
 * @param {*} boolMatchByVIN
 * Appends on to the end of the variant selector the option to match by VIN
 * if boolMatchByVIN is true and the option exists in the DOM as a hidden div
 */

function handleAppendMatchByVin(vinInput, displayMsg) {
	// Reference: resortToGetPaintCodeByVin
	const combinedVariantSelect = document.getElementById("variant-selector");
	const vin = vinInput;
	let hiddenDiv;
	let priceDifference;
	storedDecodedVin = vin;

	// We must determine if the option in variant-selector for "match paint by vin" already exists before continuing
	const existingOption = Array.from(combinedVariantSelect.options).find(
		(option) => option.label.startsWith("Match Paint by VIN")
	);

	// If there is no current existing option, then we can proceed to add it
	// We look for the hidden div that contains the option information
	// If it exists, we create a new option in the variant-selector select element
	// We then append the option to the select element and remove the hidden div from the DOM
	// Finally we auto select the option to match by VIN and formulate the message to display to the user
	if (!existingOption || existingOption === undefined) {
		if (document.querySelector(".hidden-vin-option")) {
			hiddenDiv = document.querySelector(".hidden-vin-option");
		} else if (document.querySelector(".hidden-vin-option-single-quality")) {
			hiddenDiv = document.querySelector(".hidden-vin-option-single-quality");
		}

		// Only display the option to select Match Paint by VIN in certain circumstances
		if (hiddenDiv) {
			if (!combinedVariantSelect) {
				console.error("Error: Select element not found.");
				return;
			}

			let value;
			if (hiddenDiv.getAttribute("data-value")) {
				value = hiddenDiv.getAttribute("data-value");
			} else if (hiddenDiv.getAttribute("value")) {
				value = hiddenDiv.getAttribute("value");
			}

			const text = hiddenDiv.textContent;
			const price = hiddenDiv.getAttribute("data-price") || "";
			priceDifference = hiddenDiv.getAttribute("data-price-difference") || "";
			const color = hiddenDiv.getAttribute("data-color") || "";
			const variantTitle = hiddenDiv.getAttribute("data-variant-title") || "";
			const productTitle = hiddenDiv.getAttribute("data-product-title") || "";
			const variantSKU = hiddenDiv.getAttribute("data-variant-sku") || "";
			const option = document.createElement("option");

			option.value = value;
			option.textContent = text;
			option.setAttribute("data-price", price);
			option.setAttribute("data-price-difference", priceDifference);
			option.setAttribute("data-color", color);
			option.setAttribute("data-variant-title", variantTitle);
			option.setAttribute("data-product-title", productTitle);
			option.setAttribute("data-variant-sku", variantSKU);

			option.classList.add("hidden-vin-option");

			// Append and remove
			combinedVariantSelect.appendChild(option);
			hiddenDiv.remove();
		} else {
			window.NO_MATCH_BY_VIN_OPTION_EXISTS = true;
			return "";
		}
	}

	// Unless there is no hiddenDiv (meaning that the option to match by VIN does not exist on
	// that product in Shopify), when this function is called we run the following functions
	// If the option to match by VIN does exist, it will be auto selected and the
	// message will be formulated
	// handleAutoSelectMatchByVin();
	handleFormulateVinMessage(vin, displayMsg);
	amountOfVINPostMessages++;
	return formatPriceToUSDGlobal(priceDifference);
}

/**
 * We must always call this function directly after handleAppendMatchByVin.
 * This is because the option for Match Paint by VIN does not exist as an option prior to calling that function.
 * This function will auto select the option to match by VIN if it exists in the DOM
 */
function handleAutoSelectMatchByVin() {
	const combinedVariantSelect = document.getElementById("variant-selector");
	const options = Array.from(combinedVariantSelect.options);
	options.find((option) => {
		const codeInFrontOfPrice = option.label.split("+")[0];
		if (codeInFrontOfPrice.trim() === "Match Paint by VIN") {
			combinedVariantSelect.value = option.value;
			autoSelectedColor = option.value;
			const event = new Event("change", { bubbles: true });
			combinedVariantSelect.dispatchEvent(event);
		}
	});
}

/**
 *
 * @param {*} vin
 * @param {*} displayMsg bool to display the message or not--needed if match paint by vin is determined at the garage level vs decoder level
 */
function handleFormulateVinMessage(vin, displayMsg = false) {
	// Reference: formulateMessage
	const variantSelector = document.getElementById("variant-selector");
	const paintOptionsCheckboxGroup = document.querySelector(
		".paint-options-checkbox-group"
	);
	const selectCodeFailSafe = document.querySelector(".select-code-fail-safe");
	const failSafeIsVisible = selectCodeFailSafe.style.display !== "none";

	if (variantSelector) {
		const options = Array.from(variantSelector.options);
		options.find((option) => {
			if (
				(option.label.startsWith("Match Paint by VIN") ||
					option.label.startsWith("Pintura de combinación por VIN")) &&
				document.querySelector(".vin-selected-message") === null
			) {
				const vinMessage = document.createElement("div");
				vinMessage.className = "vin-decoder-message vin-selected-message";
				vinMessage.style.display = displayMsg ? "block" : "none";
				vinMessage.innerHTML = `
                            <strong style=\"color: #444;\">${vinAttachedToOrderTranslationPayload.autoAttachMsgStrong}</strong> 
                            <span style=\"color: #000; font-weight: 800;\">${vin}</span> 
                            <span style=\"color: #444;\">${vinAttachedToOrderTranslationPayload.willBeAttached}</span> 
                            <span style=\"color: #444; font-weight: bold;\">${vinAttachedToOrderTranslationPayload.bold}</span> 
                            <span style=\"color: #444;\">${vinAttachedToOrderTranslationPayload.forThisItem}</span>
                        `;
				if (failSafeIsVisible) {
					selectCodeFailSafe.insertAdjacentElement("afterend", vinMessage);
				} else {
					paintOptionsCheckboxGroup.insertAdjacentElement(
						"afterend",
						vinMessage
					);
				}
				// }
				return true;
			}
		});
	} else {
		console.warn("Variant selector dropdown not found.");
	}
}

async function createCompanyProfile(
	companyName,
	firstName,
	lastName,
	email,
	phone,
	title,
	address,
	city,
	zipCode,
	stateAbbr,
	locationName,
	pdf,
	taxRegistrationId,
	typeText,
	reasonText
) {
	try {
		const response = await fetch(
			"https://tax-exemption-signup-505215902673.us-east5.run.app/createCustomerProfile",
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					companyName,
					firstName,
					lastName,
					email,
					phone,
					title,
					address,
					city,
					zipCode,
					stateAbbr,
					locationName,
					pdf,
					taxRegistrationId,
					typeText,
					reasonText,
				}),
			}
		);

		if (!response.ok) {
			throw new Error(
				`Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`
			);
		}
		const data = await response.json();
	} catch (error) {
		console.error("Error fetching vehicle data:", error);
	}
}

async function fetchFromBumper(vin) {
	const url = `https://bumperdotcom-api-345230973812.us-east5.run.app/bumperdotcom-api?vin=${vin}`;
	const res = await fetch(url, {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	});
	const data = await res.json();
	if (!res.ok) {
		const err = new Error("Bumper API error");
		err.status = res.status;
		err.raw = data;
		throw err;
	}
	return data;
}

async function fetchFromChromeData(vin, state, plate, location) {
	const url =
		"https://garage-vin-service-node-740168228309.us-east5.run.app/fetchVehicleData";
	const res = await fetch(url, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ vin, state, plate, location }),
	});
	const data = await res.json();
	if (!res.ok) {
		const err = new Error("ChromeData API error");
		err.status = res.status;
		err.raw = data;
		throw err;
	}
	return data;
}

// Normalize bumper and chromedata payloads into a common shape.
// We could probably reduce this function further as we are only getting the paintcode info
// from those paintcode makes, but for now we will keep all the vehicle info in case we want to
// use it later.
function normalizeBumperData(raw) {
	let errorMessage = "";
	let colorCode = "";
	let validVehicleFound = false;
	let genericDesc = "";
	let fullDescription = "";
	let hex = "";

	const vehicle = raw.entities?.vehicles?.automobiles?.[0] || {};
	const vehicleError = raw.entities?.vehicles?.automobiles.length === 0;
	// We can set vin to valid here because if it was invalid, it would have thrown and err prior to this function call
	const validVin = true;
	const design = vehicle.design || {};

	const year = vehicle.year || "";
	const make = vehicle.make || "";
	const model = vehicle.model || "";
	const submodel = vehicle.design?.trim || "";
	const engineSpecs = vehicle.specs?.engine || {};
	const cylinders = engineSpecs.cylinders;
	const size = engineSpecs.size;
	const engine =
		cylinders && size ? `${cylinders} Cyl ${Number(size).toFixed(1)}L` : "";
	const ymm = `${year} ${make} ${model} ${submodel} ${engine}`.trim();

	const colors = design.colors || [];
	const exteriorColors = colors.filter((c) => c.category === "Exterior");
	if (exteriorColors.length === 1) {
		colorCode = exteriorColors[0].code || "";
		colorCode = normalizeToyotaColorCode(make, colorCode);
		genericDesc = exteriorColors[0].generic_name || "";
		fullDescription = exteriorColors[0].name || "";
		// Sadly bumper.com does not return hex values
		hex = "";
	} else if (exteriorColors.length > 1) {
		errorMessage = `Too many paint codes to determine`;
	} else {
		errorMessage = `No exterior colors found for the provided VIN`;
	}
	if (year !== "" && make !== "" && model !== "") {
		validVehicleFound = true;
	}

	return {
		validVin,
		validVehicleFound,
		vehicleError,
		year,
		make,
		model,
		submodel,
		engine,
		ymm,
		colorCode: colorCode,
		genericDesc: genericDesc || "",
		fullDescription: fullDescription || "",
		hex: hex || "",
		site: "Bumper.com",
		decodedByBumper: true,
		errorMessage,
	};
}

function normalizeChromeData(raw) {
	let errorMessage = "";
	let colorCode = "";
	let validVehicleFound = false;
	let styleId = "";
	let genericDesc = "";
	let fullDescription = "";
	let hex = "";
	const dataResult = raw.vehicleData?.result || {};
	const year = dataResult.year || "";
	const make = dataResult.make || "";
	const model = dataResult.model || "";
	const submodel = raw?.submodel || "";
	const engine = raw?.engine || "";
	const ymm = `${year} ${make} ${model} ${submodel} ${engine}`.trim();
	const exteriorColors = dataResult.exteriorColors || [];
	if (exteriorColors.length === 1) {
		colorCode = exteriorColors[0].colorCode || "";
		colorCode = normalizeToyotaColorCode(make, colorCode);
		styleId =
			exteriorColors[0].styles.length === 1 ? exteriorColors[0].styles[0] : "";
		genericDesc = exteriorColors[0].genericDesc || "";
		fullDescription = exteriorColors[0].description || "";
		hex = exteriorColors[0].rgbHexValue || "";
	} else if (exteriorColors.length > 1) {
		errorMessage = `Too many paint codes to determine`;
	} else {
		errorMessage = `No exterior colors found for the provided VIN`;
	}
	const vehicleError = raw.vehicleData?.error || false;

	let validVin =
		dataResult.vehicleData?.message ===
		"The VIN passed was modified to convert invalid characters";
	if (validVin) {
		errorMessage = `The VIN passed was modified to convert invalid characters.`;
	} else if (dataResult.validVin.toString() === "false") {
		validVin = false;
	}
	if (year !== "" && make !== "" && model !== "") {
		validVehicleFound = true;
	}
	return {
		validVin: validVin || false,
		validVehicleFound,
		year: year || "",
		make: make || "",
		model: model || "",
		submodel: submodel || "",
		engine: engine || "",
		ymm: ymm,
		colorCode: colorCode,
		styleId: styleId,
		genericDesc: genericDesc || "",
		fullDescription: fullDescription || "",
		hex: hex || "",
		site: "ChromeData",
		decodedByBumper: false,
		errorMessage,
		vehicleError,
	};
}

// Toyota, Lexus, and Scion paint codes are always 3 digits but sometimes Bumper or Chromedata returns them as 4.
// e.g. Bumper === 0040, in reality it is 040.  So we take the last 3
function normalizeToyotaColorCode(make, code) {
	if (!code) return "";
	const m = make?.toLowerCase?.() || "";
	if (["toyota", "lexus", "scion"].includes(m)) {
		return code.slice(-3);
	}
	return code;
}

async function normalizeModelAndCompare(decodedVehicleDataPayload) {
	let errorMessage = "";

	// Validate and normalize the entire vehicle data
	const validationResult = await validateAndNormalizeVehicleData(
		decodedVehicleDataPayload
	);

	// Use normalized values from validation
	const normalizedModel =
		validationResult.model || decodedVehicleDataPayload.model;
	const normalizedSubmodel =
		validationResult.submodel || decodedVehicleDataPayload.submodel;
	const normalizedEngine =
		validationResult.engine || decodedVehicleDataPayload.engine;

	// Store validation results globally for use in showMismatchModal
	window.EASYSEARCH_VALIDATION_RESULT = validationResult;

	decodedVehicleData = {
		year: decodedVehicleDataPayload.year,
		make: decodedVehicleDataPayload.make,
		model: normalizedModel,
		submodel: normalizedSubmodel,
		engine: normalizedEngine,
		paintCode: decodedVehicleDataPayload.paintCode,
		site: decodedVehicleDataPayload.site,
		decodedByBumper: decodedVehicleDataPayload.decodedByBumper,
		description: decodedVehicleDataPayload.fullDescription,
		canResolveYMM: validationResult.canResolveYMM,
		canResolveComplete: validationResult.canResolveComplete,
	};

	// if (!window.OVERRIDE_FITMENT_CHECKER) {
	// 	// Compare with user input
	// 	mismatchDifferences = await compareWithDecoded(decodedVehicleData);
	// 	isMismatch = Object.keys(mismatchDifferences).length > 0;

	// 	if (isMismatch) {
	// 		errorMessage = `Vehicle data differences detected: ${formatDifferences(
	// 			mismatchDifferences
	// 		)}`;
	// 	}
	// }

	return {
		model: normalizedModel,
		submodel: normalizedSubmodel,
		engine: normalizedEngine,
		errorMessage,
		validationResult,
	};
}

function handleTroublesomeMake(
	make,
	previousColorCode,
	description,
	previousDecodedByBumper,
	previousErrorMessage
) {
	let colorCode = previousColorCode;
	let isCurrentVehicleTroublesome = false;
	let decodedByBumper = previousDecodedByBumper;
	let errorMessage = previousErrorMessage;

	if (
		make?.toLowerCase().length &&
		troublesomeMakesGlobal.includes(make.toLowerCase())
	) {
		isCurrentVehicleTroublesome = true;

		// If colorCode was decoded successfully and the current make is troublesome, ensure that decodedByBumper is false because we do not record
		// the paint code in this case
		// if (colorCode?.length > 0) {
		// 	decodedByBumper = false;
		// }

		// Don't attempt to match by description if not on product page
		// Return early
		if (!window.location.pathname.includes("/products/")) {
			return {
				colorCode,
				isCurrentVehicleTroublesome,
				decodedByBumper,
				errorMessage,
			};
		}
		const keys = Object.keys(productPageTroublesomeReferences);

		// First attempt: to match by description
		let matchedKey = keys.find((key) => {
			const colorArray = key.split(",").map((color) => color.trim()); // Trim spaces for clean comparison
			if (make.toLowerCase() === "volkswagen") {
				return colorArray.some((color) => color === colorCode);
			}
			return colorArray.some((color) => color === description); // Check for an exact match
		});

		// Second attempt: to match by color code if description did not match
		// This is specifically for GM vehicles
		if (!matchedKey) {
			matchedKey = keys.find((key) => {
				const colorArray = key.split(",").map((color) => color.trim()); // Trim spaces for clean comparison
				return colorArray.some((color) => color === colorCode);
			});
		}

		// If still no match, then we have a problem and log the error
		if (!matchedKey) {
			errorMessage = `Troublesome paintcode found: ${colorCode}. ${description} does not match any description in the metadata fields.`;
		}

		colorCode = matchedKey
			? productPageTroublesomeReferences[matchedKey]
			: colorCode;
	}
	successfulVinDecoding = true;
	return {
		colorCode,
		isCurrentVehicleTroublesome,
		decodedByBumper,
		errorMessage,
	};
}

function handleInvalidVehicleAttempt(
	usedLicenseLookup,
	noResults,
	failed3times,
	buttons = {}
) {
	const { vinButton = null, licenseButton = null } = buttons;
	const errorMessageVIN = document.querySelector(".errorMessageVIN");
	const errorMessageLicense = document.querySelector(".errorMessageLicense");

	if (attemptedVinsInGarage.length < decodeMaxAttempts) {
		if (usedLicenseLookup) {
			errorMessageLicense.innerHTML = noResults;
			errorMessageLicense.style.visibility = "visible";
		} else {
			errorMessageVIN.innerHTML = noResults;
			errorMessageVIN.style.visibility = "visible";
		}
		garageVinSubmissionBool = false;
		return { success: true };
	} else {
		if (usedLicenseLookup) {
			errorMessageLicense.innerHTML = failed3times;
			errorMessageLicense.style.visibility = "visible";
			document.getElementById("license").disabled = true;
			if (licenseButton) licenseButton.disabled = true;
		} else {
			errorMessageVIN.innerHTML = failed3times;
			errorMessageVIN.style.visibility = "visible";
			document.getElementById("vin").disabled = true;
			if (vinButton) vinButton.disabled = true;
		}
		return { success: false };
	}
}

function handleDecoderFailure(payload) {
	// since we have two instance now, need to check which one is present, and then select the element
	const vinElements = getVisibleVinDecoderElements();
	let activeWrapper;
	if (vinElements) {
		activeWrapper = vinElements.wrapper;
	}
	const vin = payload.vin;
	const vinErrorMsgContainer = activeWrapper.querySelector(
		".vin-error-message-container"
	);
	if (vinErrorMsgContainer) vinErrorMsgContainer.style.display = "block";
	const submissionFailedMsgClass = activeWrapper.querySelector(
		payload.submissionFailedMsgClass
	);
	const failedAttemptMsgClass = activeWrapper.querySelector(
		payload.failedAttemptMsgClass
	);
	const remainingAttemptsMsgClass = activeWrapper.querySelector(
		payload.remainingAttemptsMsgClass
	);
	const submissionFailedMsg = payload.submissionFailedMsg;
	const failedAttemptMsg = payload.failedAttemptMsg;
	const remainingAttempts = payload.remainingAttempts;
	const calculatedRemainingAttempts = payload.calculatedRemainingAttempts;

	submissionFailedMsgClass.style.display = "block";
	submissionFailedMsgClass.innerHTML = submissionFailedMsg;

	failedAttemptMsgClass.style.display = "block";
	failedAttemptMsgClass.innerHTML = failedAttemptMsg + vin;

	// Is the following if statement only for license decoder? or can it be used for both?
	if (
		failedAttemptMsgClass.style.visibility &&
		failedAttemptMsgClass.style.visibility === "hidden"
	) {
		failedAttemptMsgClass.style.visibility = "visible";
	}

	remainingAttemptsMsgClass.style.display = "block";
	remainingAttemptsMsgClass.innerHTML =
		remainingAttempts + (calculatedRemainingAttempts - 1);
}

// Only called at location 1 (Garage)
async function logGarageVehicleEvent(vin, state, plate, data = {}, error) {
	// if (!alreadyLogged) {
	// 	await logGarageEventToSheets("type", {
	// 		vin,
	// 		plate,
	// 		state,
	// 		year: data?.year || "",
	// 		make: data?.make || "",
	// 		model: data?.model || "",
	// 		submodel: data?.submodel || "",
	// 		engine: data?.engine || "",
	// 		error: error || "",
	// 		functionCall: "Garage VIN Submission",
	// 	});
	// } else {
	// 	alreadyLogged = false;
	// }
}

/*
    functionLocation - 1 = Garage
    functionLocation - 3 = Vin Decoder - Vin Lookup
    functionLocation - 4 = Vin Decoder - License Plate Lookup
*/
async function fetchVehicleDataByVin(
	state,
	plate,
	vin,
	functionLocation,
	noResults,
	failed3times,
	searchBtn,
	tailoredSuccessMessage,
	failedAttemptMsg,
	remainingAttempts,
	bumperdotcommake
) {
	// const remainingAttemptsMsgClass = document.querySelector(
	// 	'[class^="vin-decoder-remaining-attempts"]:not([style*="display: none"])'
	// );
	const vinSearchBtn = document.getElementById("vin-to-collection-btn");
	const licenseToVinbtn = document.getElementById("license-to-vin-btn");

	let calculatedRemainingAttemptsVinDecoder =
		decodeMaxAttempts - attemptedDecodedVins.length;
	let calculatedRemainingAttemptsLicenseDecoder =
		decodeMaxAttempts - attemptedDecodedLicensePlates.length;

	// COMMENTED OUT: Saves ~100ms per call
	// let partifyLocation = await getPartifyLocation();
	let partifyLocation = ""; // Skipping location lookup for performance
	let parentUrl = window.location.href;
	let data = "";
	let vehicleError = false;
	let validVin = false;
	let validVehicleFound = false;
	let chromedatamake = false;
	let decodedByBumper = false;
	let colorCode = "";
	let year = "";
	let make = "";
	let model = "";
	let submodel = "";
	let engine = "";
	let ymm = "";
	let site = "";
	let styleId = "";
	let genericDesc = "";
	let fullDescription = "";
	let hex = "";
	let errorMessage = "";
	let lastCollectionImage = "";

	try {
		// Check if vin is empty.. if so, then license lookup failed
		if (vin.length === 17) {
			// No matter what, always fetch from chromedata first to establish consistent vehicle data
			data = await fetchFromChromeData(vin, state, plate, functionLocation);
			({
				validVin,
				validVehicleFound,
				year,
				make,
				model,
				submodel,
				engine,
				ymm,
				colorCode,
				styleId,
				genericDesc,
				fullDescription,
				hex,
				site,
				decodedByBumper,
				errorMessage,
				vehicleError,
			} = normalizeChromeData(data));
			//debugger;
			// Must update the model so that it matches the easysearch model for mismatch comparison
			const decodedVehicleDataPayload = {
				year,
				make,
				model,
				submodel,
				engine,
				paintCode: colorCode,
				site,
				decodedByBumper,
				fullDescription,
			};
			({ model, submodel, engine, errorMessage, validationResult } =
				await normalizeModelAndCompare(decodedVehicleDataPayload));
			// debugger;
			// if vehicle added from garage using vin, the bumperdotcommake would be false, need to flip to true here inorder to get the paintcode
			const isProductPage =
				window.location.pathname.includes("/products/") ||
				window.location.pathname.includes("/product/") ||
				window.location.pathname.includes("/shop/");
			if (
				bumperMakesGlobal.includes(make.toLowerCase()) &&
				!isProductPage &&
				window.DISPLAY_LICENSE_PLATE_OPTION
			) {
				bumperdotcommake = true;
			}
			// If bumperdotcommake is true, and chromedata did not successfully decode the paintcode,
			// then we set the paintcode with bumper.com paintcode
			if (
				bumperdotcommake &&
				bumperdotcommake === true &&
				!colorCode.length &&
				parseInt(year) >= 2012
			) {
				data = await fetchFromBumper(vin);
				const returnedNormalizedBumperRes = normalizeBumperData(data);

				// If colorCode was not established by chromedata, then we take the bumper colorCode
				colorCode = returnedNormalizedBumperRes.colorCode;
				if (!fullDescription) {
					fullDescription = returnedNormalizedBumperRes.fullDescription;
				}
				// Update the decoded site to bumper.
				site = returnedNormalizedBumperRes.site;
				decodedByBumper = returnedNormalizedBumperRes.decodedByBumper;
			}

			// If at this point we still do not have a colorCode, we set it to .VIN to indicate
			// that the paint code could not be decoded by either chromedata or bumper.com
			// and we will therefore always resort to match paint by vin
			if (!excludedMakesGlobal.includes(make.toLowerCase())) {
				colorCode.length === 0 ? (colorCode = ".VIN") : colorCode;
			}
			// Update the variables with normalized values
			if (validationResult && validationResult.model) {
				model = validationResult.model;
			}
			if (validationResult && validationResult.submodel) {
				submodel = validationResult.submodel;
			}
			if (validationResult && validationResult.engine) {
				engine = validationResult.engine;
			}
		} else {
			vehicleError = true;
			validVin = false;
		}

		// Garage
		if (functionLocation === 1) {
			const usedLicenseLookup = Boolean(state && plate);
			// If current vehicle is troublesome, we don't want to set the paint code at the garage level
			({
				colorCode,
				isCurrentVehicleTroublesome,
				decodedByBumper,
				errorMessage,
			} = handleTroublesomeMake(
				make,
				colorCode,
				fullDescription,
				decodedByBumper,
				errorMessage
			));

			if (validVehicleFound) {
				// Don't add garageVinSubmissionBool here because there will be a time when the button
				// is clickable between submission and page navigation.  Don't want anyone spamming
				// the button.
				await logGarageVehicleEvent(vin, state, plate, decodedVehicleData, "");

				if (chromeDataMakesGlobal.includes(make.toLowerCase())) {
					chromedatamake = true;
				}

				validVehicleFound = await updateGarageAndNavigate(
					year.toString(),
					make,
					model,
					submodel,
					engine,
					vin,
					colorCode,
					state,
					plate,
					decodedByBumper,
					lastCollectionImage
				);
			}

			// validVehicleFound can change from true to false if updateGarageAndNavigate does not find a valid YMM in the easysearch dropdowns
			// Consequently, it must be treated as an invalid vehicle
			if (!validVehicleFound) {
				await logGarageVehicleEvent(
					vin,
					state,
					plate,
					decodedVehicleData,
					"Could not find matching YMM in EasySearch dropdowns."
				);
				handleInvalidVehicleAttempt(usedLicenseLookup, noResults, failed3times);

				return {
					validVin: validVehicleFound,
					ymm: ymm,
					paintCode: colorCode || "",
					decodedByBumper: decodedByBumper,
				};
			}
			return {
				validVin: validVehicleFound,
				ymm: ymm,
				paintCode: colorCode || "",
				decodedByBumper: decodedByBumper,
			};
			// Vin Decoder
		} else if (functionLocation === 3) {
			if (attemptedDecodedVins.length <= decodeMaxAttempts) {
				({
					colorCode,
					isCurrentVehicleTroublesome,
					decodedByBumper,
					errorMessage,
				} = handleTroublesomeMake(
					make,
					colorCode,
					fullDescription,
					decodedByBumper,
					errorMessage
				));

				mismatchDifferences = await compareWithDecoded(decodedVehicleData);

				isMismatch = Object.keys(mismatchDifferences).length > 0;
				if (isMismatch) {
					errorMessage = `Vehicle data differences detected: ${formatDifferences(
						mismatchDifferences
					)}`;
				}

				if (vehicleError === false || validVin === true) {
					return {
						validVin: true,
						ymm: ymm,
						paintCode: colorCode || "",
						decodedByBumper: decodedByBumper,
						isCurrentVehicleTroublesome: isCurrentVehicleTroublesome,
					};
				} else {
					if (errorMessage === "") {
						errorMessage = `VIN Decoder: Error fetching vehicle data.`;
					}
					const decoderFailurePayload = {
						vin,
						submissionFailedMsgClass: ".vin-decoder-submission-failed-message",
						failedAttemptMsgClass: ".vin-decoder-failed-attempt",
						remainingAttemptsMsgClass: ".vin-decoder-remaining-attempts",
						// remainingAttemptsMsgClass: remainingAttemptsMsgClass,
						submissionFailedMsg: noResults,
						failedAttemptMsg: failedAttemptMsg,
						remainingAttempts,
						calculatedRemainingAttempts: calculatedRemainingAttemptsVinDecoder,
					};
					//here
					if (colorCode !== ".VIN") handleDecoderFailure(decoderFailurePayload);

					return {
						validVin: false,
						ymm: "",
						paintCode: colorCode || "",
						decodedByBumper: null,
						isCurrentVehicleTroublesome: isCurrentVehicleTroublesome,
					};
				}
			} else {
				// Vin Decoder failed 3 times
				if (errorMessage === "") {
					errorMessage = `Failed 3 times. Error fetching vehicle data.`;
				}
				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass: ".vin-decoder-submission-failed-message",
					failedAttemptMsgClass: ".vin-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".vin-decoder-remaining-attempts",
					// remainingAttemptsMsgClass: remainingAttemptsMsgClass,

					submissionFailedMsg: failed3times,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts: calculatedRemainingAttemptsVinDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);

				successfulVinDecoding = false;
				return {
					validVin: false,
					ymm: "",
					paintCode: colorCode || "",
					decodedByBumper: null,
					isCurrentVehicleTroublesome: isCurrentVehicleTroublesome,
				};
			}
			// License Decoder
		} else if (functionLocation === 4) {
			if (attemptedDecodedLicensePlates.length <= decodeMaxAttempts) {
				({
					colorCode,
					isCurrentVehicleTroublesome,
					decodedByBumper,
					errorMessage,
				} = handleTroublesomeMake(
					make,
					colorCode,
					fullDescription,
					decodedByBumper,
					errorMessage
				));

				mismatchDifferences = await compareWithDecoded(decodedVehicleData);
				isMismatch = Object.keys(mismatchDifferences).length > 0;
				if (isMismatch) {
					errorMessage = `Vehicle data differences detected: ${formatDifferences(
						mismatchDifferences
					)}`;
				}

				if (vehicleError === false || validVin === true) {
					return {
						validVin: true,
						ymm: ymm,
						paintCode: colorCode || "",
						decodedByBumper: decodedByBumper,
					};
				} else {
					if (errorMessage === "") {
						errorMessage = `License Decoder: Error fetching vehicle data.`;
					}
					const decoderFailurePayload = {
						vin,
						submissionFailedMsgClass:
							".license-decoder-submission-failed-message",
						failedAttemptMsgClass: ".license-decoder-failed-attempt",
						remainingAttemptsMsgClass: ".license-decoder-remaining-attempts",
						submissionFailedMsg: noResults,
						failedAttemptMsg: failedAttemptMsg,
						remainingAttempts,
						calculatedRemainingAttempts:
							calculatedRemainingAttemptsLicenseDecoder,
					};
					handleDecoderFailure(decoderFailurePayload);

					return {
						validVin: false,
						ymm: "",
						paintCode: colorCode || "",
						decodedByBumper: null,
					};
				}
			} else {
				if (errorMessage === "") {
					errorMessage = `Failed 3 times. Error fetching vehicle data.`;
				}

				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass:
						".license-decoder-submission-failed-message",
					failedAttemptMsgClass: ".license-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".license-decoder-remaining-attempts",
					submissionFailedMsg: failed3times,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts:
						calculatedRemainingAttemptsLicenseDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);

				successfulVinDecoding = false;
				return {
					validVin: false,
					ymm: "",
					paintCode: colorCode || "",
					decodedByBumper: null,
				};
			}
		}
	} catch (error) {
		if (functionLocation === 1) {
			const usedLicenseLookup = Boolean(state && plate);
			handleInvalidVehicleAttempt(usedLicenseLookup, noResults, failed3times);
			if (usedLicenseLookup) {
				await logGarageVehicleEvent(vin, state, plate, {}, error.message);
			} else {
				await logGarageVehicleEvent(vin, "", "", {}, error.message);
			}
		} else if (functionLocation === 3) {
			// attemptedDecodedVins.push(vin);
			if (attemptedDecodedVins.length < decodeMaxAttempts) {
				if (errorMessage === "") {
					errorMessage = `[CATCH] Garage: Error fetching vehicle data: ${error.message}`;
				}
				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass: ".vin-decoder-submission-failed-message",
					failedAttemptMsgClass: ".vin-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".vin-decoder-remaining-attempts",
					// remainingAttemptsMsgClass: remainingAttemptsMsgClass,

					submissionFailedMsg: noResults,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts: calculatedRemainingAttemptsVinDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);
			} else {
				if (errorMessage === "") {
					errorMessage = `Failed 3 times. Error fetching vehicle data: ${error.message}`;
				}
				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass: ".vin-decoder-submission-failed-message",
					failedAttemptMsgClass: ".vin-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".vin-decoder-remaining-attempts",
					// remainingAttemptsMsgClass: remainingAttemptsMsgClass,

					submissionFailedMsg: failed3times,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts: calculatedRemainingAttemptsVinDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);
			}
			return {
				validVin: false,
				ymm: "",
				paintCode: colorCode || "",
				decodedByBumper: null,
			};
		} else if (functionLocation === 4) {
			const licenseDecoderFailedAttemptClass = document.querySelector(
				".license-decoder-failed-attempt"
			);
			const licenseDecoderSubmissionFailedMessageClass = document.querySelector(
				".license-decoder-submission-failed-message"
			);
			const licenseDecoderRemainingAttemptsClass = document.querySelector(
				".license-decoder-remaining-attempts"
			);
			if (attemptedDecodedLicensePlates.length <= decodeMaxAttempts) {
				if (errorMessage === "") {
					errorMessage = `[CATCH] License Decoder: Error fetching vehicle data: ${error.message}`;
				}
				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass:
						".license-decoder-submission-failed-message",
					failedAttemptMsgClass: ".license-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".license-decoder-remaining-attempts",
					submissionFailedMsg: noResults,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts:
						calculatedRemainingAttemptsLicenseDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);
			} else {
				if (errorMessage === "") {
					errorMessage = `Failed 3 times. Error fetching vehicle data: ${error.message}`;
				}
				const decoderFailurePayload = {
					vin,
					submissionFailedMsgClass:
						".license-decoder-submission-failed-message",
					failedAttemptMsgClass: ".license-decoder-failed-attempt",
					remainingAttemptsMsgClass: ".license-decoder-remaining-attempts",
					submissionFailedMsg: noResults,
					failedAttemptMsg: failedAttemptMsg,
					remainingAttempts,
					calculatedRemainingAttempts:
						calculatedRemainingAttemptsLicenseDecoder,
				};
				handleDecoderFailure(decoderFailurePayload);
			}
			return {
				validVin: false,
				ymm: "",
				paintCode: colorCode || "",
				decodedByBumper: null,
			};
		}
		console.error("Error fetching vehicle data:", error);
	} finally {
		if (functionLocation === 1) {
			vinSearchBtn.classList.remove("vin-to-collection-btn--loading");
			vinSearchBtn.innerHTML = searchBtn;
		}

		if (functionLocation === 3 || functionLocation === 4) {
			decoderLoggerWebhook(
				state,
				plate,
				vin,
				site,
				year,
				make,
				model,
				submodel,
				engine,
				styleId,
				colorCode,
				errorMessage,
				partifyLocation,
				parentUrl,
				genericDesc,
				fullDescription,
				hex
			);
		}
	}
}

function cleanLicensePlate(state, dirtyPlate, oRestrictedStates) {
	// Remove spaces and trim the plate input
	let plate = dirtyPlate ? dirtyPlate.replace(/[\s-]+/g, "").trim() : "";
	// Only modify the plate if the state is in the list of states that restrict the letter O
	if (oRestrictedStates.includes(state)) {
		plate = plate.replace(/O/g, "0");
	}
	return plate;
}

// function to compare stored data with decodedData
async function compareWithDecoded(decodedData) {
	const userInput = getSearchTerms()[0] || {};
	const easyModel = decodedData?.model;
	if (easyModel) decodedData.model = easyModel;
	const differences = {};

	// REMOVE THE SUBMODEL | ENGINE FROM THE KEYSTOCOMPARE< WE DONT NEED THEM HERE
	// TODO: NEED TO FILP THEM BACK ONCE FINISHING THE REFERENCING
	// const keysToCompare = ["year", "make", "model", "submodel", "engine"];
	const keysToCompare = ["year", "make", "model"];
	for (const key of keysToCompare) {
		if (
			userInput[key] &&
			decodedData[key] &&
			userInput[key].toString().toLowerCase() !==
				decodedData[key].toString().toLowerCase()
		) {
			differences[key] = {
				user: userInput[key],
				decoded: decodedData[key],
			};
		}
	}

	// keep for debug
	// if (Object.keys(differences).length > 0) {
	// 	console.log("Vehicle data differences detected:", differences); // Keep for debug
	// }

	return differences;
}

// New helper function (add this anywhere in the utilities section)

function formatDifferences(differences) {
	return Object.entries(differences)

		.map(
			([key, { user, decoded }]) =>
				`${
					key.charAt(0).toUpperCase() + key.slice(1)
				} (User: ${user}, Decoded: ${decoded})`
		)

		.join(", ");
}

function formatPriceToUSDGlobal(price) {
	if (!price) return;

	if (price.trim().startsWith("$")) {
		return price;
	}
	const formattedPrice = (price / 100).toFixed(2);
	return "$" + formattedPrice;
}

// Uncomment the following function whenever we get more bumper credits
async function fetchBumpersLicenseToVin(state, plate) {
	try {
		alreadyLogged = false;
		const response = await fetch(
			`https://license-to-vin-273472976974.us-east5.run.app/license-to-vin?state=${state}&plate=${plate}`,
			{
				method: "Get",
				headers: { "Content-Type": "application/json" },
			}
		);

		if (!response.ok) {
			throw new Error(
				`Error fetching order details. Status: ${response.status}. Message: ${response.statusText}.`
			);
		}
		const data = await response.json();
		const vin = data.entities?.vehicles?.automobiles[0]?.vin;
		const year = data.entities?.vehicles?.automobiles[0]?.year;
		const make = data.entities?.vehicles?.automobiles[0]?.make;
		const model = data.entities?.vehicles?.automobiles[0]?.model;
		let submodel = data.entities.vehicles.automobiles[0]?.design?.trim || "";
		let engine;
		const engineSpecs = data.entities.vehicles.automobiles[0]?.specs?.engine;
		const cylinders = engineSpecs?.cylinders;
		const size = engineSpecs?.size?.toFixed(1);
		if (cylinders && size) {
			engine = `${cylinders} Cyl ${size}L`;
		} else {
			engine = "";
		}
		if (data.entities?.vehicles?.automobiles.length > 0) {
			// Fire-and-forget: log in background
			logGarageEventToSheets("type", {
				vin: vin,
				plate: plate,
				state: state,
				year: year,
				make: make,
				model: model,
				submodel: submodel,
				engine: engine,
				error: "",
				functionCall: "License To VIN",
			});

			alreadyLogged = true;
		} else {
			console.error("No vehicles found for the provided license plate.");
			document.getElementById("license-to-vin-btn").disabled = true;
			document.querySelector(".errorMessageLicense").style.visibility =
				"visible";
			document.querySelector(".errorMessageLicense").innerHTML =
				"No vehicles found for the provided license plate.";
			// Fire-and-forget: log in background
			logGarageEventToSheets("type", {
				vin: vin,
				plate: plate,
				state: state,
				year: year,
				make: make,
				model: model,
				submodel: submodel,
				engine: engine,
				error: "No vehicles found for the provided license plate.",
				functionCall: "License To VIN",
			});
		}

		return { vin, year, make, model };
	} catch (error) {
		// Fire-and-forget: log in background
		logGarageEventToSheets("type", {
			vin: vin,
			plate: plate,
			state: state,
			year: "",
			make: "",
			model: "",
			submodel: "",
			engine: "",
			error: error.message,
			functionCall: "License To VIN",
		});
		document.getElementById("license-to-vin-btn").disabled = true;
		document.querySelector(".errorMessageLicense").style.visibility = "visible";
		document.querySelector(".errorMessageLicense").innerHTML =
			"Error fetching vehicle data. Please try again later.";
		console.error("Error fetching vehicle data:", error);
		throw new Error("Failed to fetch vehicle data", { cause: error });
	}
}

async function handleVinDecode(
	vinInput,
	state,
	licensePlate,
	location,
	bumperdotcommake,
	failed3timesmsg,
	noResults,
	searchBtn,
	tailoredSuccessMessage,
	failedAttemptMsg,
	remainingAttempts,
	vinDecoderFirstMsg,
	vinDecoderEndMsg,
	forceSelectMsgStart,
	forceSelectMsgEnd
) {
	if (location === 1) {
		window.igEvents = window.igEvents || [];
		window.igEvents.push({ event: "vinEntryAtGarage" });
	} else if (location === 3 || location === 4) {
		window.igEvents = window.igEvents || [];
		window.igEvents.push({ event: "vinEntryAtVinDecoder" });
	}

	let exteriorColor = "";

	// Returns isVinValid and Paint code (if no paint code, returns empty string)
	const {
		validVin,
		ymm,
		paintCode,
		decodedByBumper,
		isCurrentVehicleTroublesome,
	} = await fetchVehicleDataByVin(
		state,
		licensePlate,
		vinInput,
		location,
		noResults,
		failed3timesmsg,
		searchBtn,
		tailoredSuccessMessage,
		failedAttemptMsg,
		remainingAttempts,
		bumperdotcommake
	);
	if (validVin) {
		// Vin is valid and paint code is found
		const { matchingOption, noPaintVariants } = handleAutoSelectColor(
			paintCode,
			vinInput,
			licensePlate,
			location,
			vinDecoderFirstMsg,
			vinDecoderEndMsg,
			forceSelectMsgStart,
			forceSelectMsgEnd
		);
		// Break early if no paint variants -- meaning we do not know all of the paint variants to select
		// from in the event of a troublesome make--this is determined after the quality is selected
		if (noPaintVariants) {
			return validVin;
		}
		let searchTerms = getSearchTerms();
		if (!isMismatch) {
			searchTerms[0].vin = vinInput;
			if (state) {
				searchTerms[0].state = state;
			}
			if (licensePlate) {
				searchTerms[0].plate = licensePlate;
			}
			// to avoid attaching paintcode for troublesome makes
			if (
				matchingOption ||
				searchTerms[0].paintCode === null ||
				isCurrentVehicleTroublesome
			) {
				searchTerms[0].paintCode = paintCode;
			}

			// Need this because may decode the paint code but did not find matching option
			// In here, will set the decodedByBumper......
			if (paintCode !== "") {
				if (Array.isArray(searchTerms) && searchTerms.length > 0) {
					const firstYMM = searchTerms[0].ymm || "";
					if (firstYMM === ymm) {
						searchTerms[0].paintCode = paintCode;
					}
				}
			}

			// If the paint code for the first vehicle (searchTerm) is the same as the paintCode returned from decoding,
			// we can safely set the decodedByBumper value
			if (searchTerms[0].paintCode === paintCode) {
				searchTerms[0].decodedByBumper = decodedByBumper;
			}

			setSearchTerms(searchTerms, 5);
			window.GarageLogic.updateGaragePopup(getSearchTerms());
		}
	} else if (
		!validVin &&
		paintCode === ".VIN" &&
		(location === 3 || location === 4)
	) {
		// Handle case when VIN decode failed but we still have .VIN as paintCode
		// Call handleAutoSelectColor to trigger the Match Paint by VIN flow
		handleAutoSelectColor(
			paintCode,
			vinInput,
			licensePlate,
			location,
			vinDecoderFirstMsg,
			vinDecoderEndMsg,
			forceSelectMsgStart,
			forceSelectMsgEnd
		);

		let searchTerms = getSearchTerms();
		if (!isMismatch && Array.isArray(searchTerms) && searchTerms.length > 0) {
			searchTerms[0].vin = vinInput;
			if (state) {
				searchTerms[0].state = state;
			}
			if (licensePlate) {
				searchTerms[0].plate = licensePlate;
			}
			searchTerms[0].paintCode = paintCode;
			setSearchTerms(searchTerms, 5);
			window.GarageLogic.updateGaragePopup(getSearchTerms());
		}
	}

	return validVin;
}

/**
 * Handles the scenario when vehicles fail to decode paint codes.
 * If the global toggle for matching paint by VIN is enabled, it attempts to append
 * the match by VIN price and updates the UI accordingly.
 *
 * If no match by VIN price is found, it resorts to forcing the user to select a paint code
 */
function handleVehiclesFailedToDecodePaint(
	vinInput,
	licensePlate,
	forceSelectMsgStart,
	forceSelectMsgEnd,
	location,
	autoSelectColor
) {
	if (window.TOGGLE_MATCH_PAINT_BY_VIN) {
		const matchPaintByVinPrice = handleAppendMatchByVin(
			vinInput,
			autoSelectColor
		);

		// In some cases (let's say there is no hidden div because the part does not have the
		// match by vin option), the matchPaintByVinPrice will be null or empty string
		// Therefore we must force them to select a code
		if (!matchPaintByVinPrice) {
			// If empty, jump to else logic
			resortToForceSelectCode();
			formulateForcePaintCodeSelectMsg(
				vinInput,
				licensePlate,
				forceSelectMsgStart,
				forceSelectMsgEnd,
				location
			);
		} else {
			matchingPaintByVinVisible = true;
			storedOptionLabel.style.display = "block";
			checkboxStoredCodeText.innerHTML =
				matchPaintByVinTranslationKey + " +" + matchPaintByVinPrice;

			if (autoSelectColor) {
				const checkboxUseStoredCode = document.getElementById(
					"checkbox-paint-code-local-storage"
				);
				checkboxUseStoredCode.checked = true;
				const paintCodeWrapperGlobal = document.querySelector(
					".paint-code-wrapper"
				);
				if (paintCodeWrapperGlobal.classList.contains("show")) {
					paintCodeWrapperGlobal.classList.remove("show");
				}
			}
		}
	} else {
		resortToForceSelectCode();
		formulateForcePaintCodeSelectMsg(
			vinInput,
			licensePlate,
			forceSelectMsgStart,
			forceSelectMsgEnd,
			location
		);
	}
}

function handleAutoSelectColor(
	paintCode,
	vinInput,
	licensePlate,
	location,
	decoderFirstMsg,
	decoderEndMsg,
	forceSelectMsgStart,
	forceSelectMsgEnd
) {
	const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
	const paintcodeAppContainer = document.getElementById(
		"paintcode-app-container"
	);
	const variantSelector = document.getElementById("variant-selector");
	const paintedStockKeyLevel = document.querySelector(
		".painted-stock-key-paint-level"
	);
	const paintOptionsVinLicense = document.querySelector(
		".paint-options-vin-license"
	);
	let matchingOption = false;

	// Trigger modal for any mismatch on product page
	const isProductPage =
		window.location.pathname.includes("/products/") ||
		window.location.pathname.includes("/product/") ||
		window.location.pathname.includes("/shop/");

	if (isMismatch && isProductPage) {
		showMismatchModal(mismatchDifferences, vinInput, licensePlate, paintCode);
		return false; // stop to show modal
	}

	if (variantSelector) {
		const options = Array.from(variantSelector.options);

		// If on product page and a quality hasn't been selected yet, then there will only be one option -- 'Select Paint Code'
		// If the paintCode is not .VIN, then we can assume it was either successfully decoded or has yet to be decoded
		if (options.length === 1) return { matchingOption, noPaintVariants: true };
		options.find((option) => {
			const codeInFrontOfPrice = option.label.split("+")[0];

			// In some instances, we have the same paint code but the color itself varies between years:
			// e.g. PBM (2006-2013) +$153.00 and PBM (2018-2023) +$153.00
			// if (codeInFrontOfPrice.includes("(")) {
			if (codeInFrontOfPrice.trim() === paintCode) {
				matchingOption = true;
				if (option.textContent.includes("🚚")) {
					decodedVINHasAvailableStock = true;
				}
				autoSelectedColor = option.value;
				autoSelectedOption = option;
				return { matchingOption, noPaintVariants: false };
			}
		});

		if (matchingOption) {
			storedDecodedVin = vinInput;

			// Set the selectedVariantUnavailable to false to enable the addToCart button
			// We can do this because we know we already have the VIN
			selectedVariantUnavailable = false;
			if (autoSelectedOption.dataset.unavailable === "true") {
				autoSelectedBanned = true;
			}

			variantSelector.value = autoSelectedColor;
			document.body.classList.remove("no-scroll-paint-swatch");
			if (window.enablePrepaintedMessaging) {
				if (decodedVINHasAvailableStock) {
					paintedStockKeyLevel.style.display = "block";
				}
			}
			// Trigger the change event programmatically
			const autoselectEvent = new Event("change", { bubbles: true });
			autoselectEvent._fromAutoSelect = true;
			variantSelector.dispatchEvent(autoselectEvent);
			if (typeof vinInputLibrary !== "undefined" && vinInputLibrary) {
				vinInputLibrary.value = vinInput;
			}
		} else {
			// Either match paint by vin or force select code
			handleVehiclesFailedToDecodePaint(
				vinInput,
				licensePlate,
				forceSelectMsgStart,
				forceSelectMsgEnd,
				location,
				true
			);
			handleAutoSelectMatchByVin();
			hideGiveUsYourVinMsg();
			paintOptionsVinLicense.classList.add("hidden");
			console.warn(
				`No matching option found for paint code: ${paintCode} using the vin: ${vinInput}`
			);
		}
	} else {
		console.warn("Variant selector dropdown not found.");
		return { matchingOption, noPaintVariants: true };
	}

	if (location === 3) {
		const paintCodeAppContainer = document.getElementById(
			"paintcode-app-container"
		);
		if (paintCodeAppContainer) paintCodeAppContainer.classList.remove("show");
	}

	if (location === 4) {
		const paintCodeAppContainerLicense = document.getElementById(
			"paintcode-app-container-license"
		);
		if (paintCodeAppContainerLicense)
			paintCodeAppContainerLicense.classList.remove("show");
	}

	if (!window.TOGGLE_MATCH_PAINT_BY_VIN) {
		if (paintCodeWrapper) paintCodeWrapper.classList.add("show");
	} else {
		if (paintCodeWrapper) paintCodeWrapper.classList.remove("show");
	}

	// If searching from the garage and not on the product page, there won't be a
	// variantSelector, therefore, we must return noPaintVariants as true
	if (location === 1 && !window.location.pathname.includes("/products/")) {
		return { matchingOption, noPaintVariants: true };
	}

	return { matchingOption, noPaintVariants: false };
}

function handleInsertLocalStoragePaintOption() {
	const garageSearchTerms = getSearchTerms();
	const combinedVariantSelector = document.getElementById("variant-selector");
	let firstItemColor = "";
	let firstItemState = "";
	let firstItemPlate = "";
	let firstItemVin = "";
	let foundMatchingColor = false;
	if (garageSearchTerms && garageSearchTerms.length) {
		firstItemColor = garageSearchTerms[0]?.paintCode;
		firstItemState = garageSearchTerms[0]?.state;
		firstItemPlate = garageSearchTerms[0]?.plate;
		firstItemVin = garageSearchTerms[0]?.vin;

		// If the color exists in local storage
		if (firstItemColor) {
			const allVariantOptions = window.productVariants;

			// Set sampleArrToCheck to the first existing array within window.productVariants (NOTE: all product qualities should have the same
			// paint variants)
			const sampleArrToCheck =
				allVariantOptions.aftermarket ||
				allVariantOptions.capa ||
				allVariantOptions.oem ||
				allVariantOptions.current ||
				allVariantOptions.single;

			const unpaintedOption = sampleArrToCheck[0];
			for (let i = 0; i < sampleArrToCheck.length; i++) {
				const option = sampleArrToCheck[i];

				if (
					firstItemColor === option.variantTitle ||
					firstItemColor === option.title
				) {
					let priceDifference = option.priceDifference || null;
					if (priceDifference === null) {
						// we need to search through all the options of combinedVariantSelector to find the priceDifference, which is an attribute data-price-difference
						const allOptions = Array.from(combinedVariantSelector.options);
						const matchedOption = allOptions.find((opt) => {
							const codeInFrontOfPrice = opt.label.split("+")[0];
							return codeInFrontOfPrice.trim() === firstItemColor.trim();
						});
						if (matchedOption) {
							priceDifference = matchedOption.dataset.priceDifference;
						} else {
							priceDifference = 0;
						}
					}

					decodedPaintedOptionPrice = (priceDifference / 100).toLocaleString(
						"en-US",
						{
							style: "currency",
							currency: "USD",
						}
					);
					foundMatchingColor = true;
				}
			}

			// If the color stored in local storage is found to match a variant option, display matching option and hide VIN and license option
			if (foundMatchingColor) {
				storedOptionLabel.style.display = "block";
				failSafeSelectCodeOptionLabel.style.display = "block";
				if (selectCodeOptionLabel) selectCodeOptionLabel.style.display = "none";
				// Formats the checkbox to look like: "Painted [color] +[price]"
				if (decodedPaintedOptionPrice.length) {
					checkboxStoredCodeText.innerHTML =
						decodedPaintedOptionPainted +
						" " +
						firstItemColor +
						" +" +
						decodedPaintedOptionPrice;
				} else if (decodedPaintedOptionPrice.length === 0) {
					checkboxStoredCodeText.innerHTML =
						decodedPaintedOptionPainted + " " + firstItemColor;
				}

				// If both state and plate exist in local storage, render the paint option message accordingly
				if (firstItemState && firstItemPlate) {
					const localStatePlate = firstItemState + "-" + firstItemPlate;
					displayStoredPaintCodeMsg(false, localStatePlate, firstItemColor);
					hideGiveUsYourVinMsg();

					// If no state or plate exist but a vin does, render the paint option accordingly
				} else if (firstItemVin) {
					const localVin = firstItemVin;
					displayStoredPaintCodeMsg(true, localVin, firstItemColor);
					hideGiveUsYourVinMsg();
				}
				if (paintOptionGroup) {
					paintOptionGroup.style.display = "none";
				}

				// If the color stored in local storage does not match a variant option, just hide VIN and license option
			} else {
				if (paintOptionGroup) {
					paintOptionGroup.style.display = "none";
				}
				hideGiveUsYourVinMsg();
			}

			// If vehicle exists in garage but does not have a color associated with it yet,
			// ensure the VIN and license options are displayed
		} else {
			if (paintOptionGroup) {
				paintOptionGroup.style.display = "block";
			}
		}
	}

	return firstItemColor;
}

function displayStoredPaintCodeMsg(isVin, vinOrLicense, color) {
	storedDecodedPaintCodeMsgGlobal.style.display = "block";
	const licenseOrVinSpan = document.querySelector(
		".stored-paint-code-license-or-vin"
	);
	const colorSpan = document.querySelector(".stored-paint-code-color");

	if (isVin) {
		licenseOrVinSpan.textContent = vinWord + " " + vinOrLicense + ",";
	} else {
		licenseOrVinSpan.textContent = licensePlateWord + " " + vinOrLicense + ",";
	}
	colorSpan.textContent = color + ".";
}

function hideGiveUsYourVinMsg() {
	const giveUsYourVinMsg = document.querySelector(".give-us-your-vin-msg");
	if (giveUsYourVinMsg) giveUsYourVinMsg.style.display = "none";
}

function resortToForceSelectCode() {
	const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
	const paintCodeCheckbox = document.getElementById(
		"checkbox-select-paint-option"
	);
	const fakeCheckboxCircle = document.getElementById(
		"fake-checkbox-get-paint-code-with-license-or-vin"
	);
	paintCodeWrapper.classList.add("show");
	paintCodeCheckbox.checked = true;

	// Hide both vin and license checkboxes if they exist
	if (paintOptionGroup) {
		paintOptionGroup.style.display = "none";
	}

	// the fake check should be removed
	fakeCheckboxCircle.checked = false;
}

function formulateForcePaintCodeSelectMsg(
	vin,
	licensePlate,
	forceSelectMsgStart,
	forceSelectMsgEnd,
	location
) {
	const isProductPage = window.location.pathname.includes("/products/");
	if (isMismatch && isProductPage) {
		// Check if modal is already visible to avoid duplicates
		const modalContainer = document.querySelector(".mismatch-modal-container");
		if (modalContainer && modalContainer.style.display !== "none") {
			return; // Already shown
		}

		showMismatchModal(mismatchDifferences, vin, licensePlate, paintCode);
	} else if (!isMismatch) {
		const vinDecoderMessage = document.querySelector(".vin-decoder-message");
		if (!vinDecoderMessage) {
			const paintCodeWrapper = document.querySelector(".paint-code-wrapper");
			// const existingMessage = vinTextboxContainer.querySelector('.vin-selected-message');
			// vinTextboxContainer.style.display = "block";

			// // Remove any existing message to avoid duplication
			// if (existingMessage) {
			//   existingMessage.remove();
			// }

			// Create a new message to indicate the selected VIN
			const vinMessage = document.createElement("div");
			vinMessage.className = "vin-decoder-message resort-to-force-select";
			vinMessage.style.display = "block";
			if (location === 3) {
				vinMessage.innerHTML = `
        <strong style="color: #444;">${forceSelectMsgStart}</strong> 
        <span style="color: #000; font-weight: 800;">${vin}.</span> 
        <span style="color: #444;">${forceSelectMsgEnd}</span> 
      `;
			}

			if (location === 4) {
				vinMessage.innerHTML = `
        <strong style="color: #444;">${forceSelectMsgStart}</strong> 
        <span style="color: #000; font-weight: 800;">${licensePlate}.</span> 
        <span style="color: #444;">${forceSelectMsgEnd}</span> 
      `;
			}
			vinMessage.style.backgroundColor = "#ffbc2c17";
			vinMessage.style.border = "1px solid #ffae00";

			failedVinDecode = true;

			// Append the message to the VIN textbox container
			paintCodeWrapper.appendChild(vinMessage);
		}
	}
}

async function decoderLoggerWebhook(
	state,
	plate,
	vin,
	site,
	year,
	make,
	model,
	submodel,
	engine,
	styleId,
	code,
	error,
	partifyLocation,
	parentUrl,
	genericDesc,
	fullDescription,
	hex
) {
	try {
		const response = await fetch(
			"https://script.google.com/macros/s/AKfycbyZxJM6lMzTVo_kfJIKIZbbz1gjo_xqE0LMgNYs1qWwpDUgjh6pmziBltVbzvxq5fVndg/exec",
			{
				redirect: "follow",
				method: "POST",
				headers: {
					"Content-Type": "text/plain;charset=UTF-8",
				},
				body: JSON.stringify({
					state: state,
					plate: plate,
					vin: vin,
					site: site,
					year: year,
					make: make,
					model: model,
					submodel: submodel,
					engine: engine,
					styleId: styleId,
					code: code,
					error: error,
					themeName: themeName,
					partifyLocation: partifyLocation,
					parentUrl: parentUrl,
					genericDesc: genericDesc,
					fullDescription: fullDescription,
					hex: hex,
				}),
			}
		);

		// If the response is not JSON, log it as text to debug
		const text = await response.text();
		// Try parsing the JSON only if the response status is OK
		if (response.ok) {
			const result = JSON.parse(text);
			return result;
		} else {
			console.error("Server responded with an error:", text);
		}
	} catch (error) {
		console.error("Error submitting logs:", error);
	}
}

async function logGarageEventToSheets(logWay, payload, ...rest) {
	let endpoint = "";
	try {
		// Optionally add timestamp if not present
		if (logWay === "dropdown") {
			const raw = localStorage.getItem("searchTerms");

			if (raw) {
				const parseData = JSON.parse(raw);
				if (Array.isArray(parseData) && parseData.length > 0) {
					payload.year = parseData[0].year || "";
					payload.make = parseData[0].make || "";
					payload.model = parseData[0].model || "";
					payload.submodel = parseData[0].submodel || "";
					payload.engine = parseData[0].engine || "";
					payload.currentPage = parseData[0].currentPage || "";
				}
			}
			endpoint =
				"https://script.google.com/macros/s/AKfycbyufCNIVCej7CBjGLcv23qfPqD5lFTyh4XLhze8RWun7V4dp4py1obPsXy-U2RhoKmd/exec";
		}

		// Optionally add themeName and partifyLocation if available
		if (logWay === "type") {
			if (typeof themeName !== "undefined" && themeName && !payload.themeName) {
				payload.themeName = themeName;
			}
			// COMMENTED OUT: Saves ~100ms
			// if (
			// 	typeof getPartifyLocation === "function" &&
			// 	!payload.partifyLocation
			// ) {
			// 	const loc = await getPartifyLocation();
			// 	payload.partifyLocation = loc;
			// }
			endpoint =
				"https://script.google.com/macros/s/AKfycbwfmcyBq79Foiipq9GpPgS4EuPUvocnbd5GYrLZvrTF30ZFOTOkKFoL64f-T01CDW38Og/exec";
		}

		const response = await fetch(endpoint, {
			redirect: "follow",
			method: "POST",
			headers: {
				"Content-Type": "text/plain;charset=UTF-8",
			},
			body: JSON.stringify(payload),
		});
		const text = await response.text();
		if (response.ok) {
			try {
				return JSON.parse(text);
			} catch (e) {
				return text;
			}
		} else {
			console.error("Server responded with an error:", text);
		}
	} catch (error) {
		console.error("Error submitting logs:", error);
	}
}

// COMMENTED OUT: Saves ~100ms per call
// async function getPartifyLocation() {
// 	const ip = await getIpAddress();

// 	let partifyLocation = "";
// 	if (ip === "107.5.210.48") {
// 		partifyLocation = "Warren";
// 	} else if (
// 		ip === "98.209.126.177" ||
// 		ip === "68.34.24.103" ||
// 		ip === "68.34.24.104"
// 	) {
// 		partifyLocation = "Fraser";
// 	}

// 	return partifyLocation;
// }

function toggleProductDoesNotFitMsg(doesNotFit) {
	let vehicleList = document.querySelector(".vehicle-list");
	if (vehicleList) {
		let failToFitMsg = document.querySelector(
			".product-does-not-fit-garage-msg"
		);
		if (!failToFitMsg) {
			failToFitMsg = document.createElement("div");
			failToFitMsg.className = "product-does-not-fit-garage-msg";
			failToFitMsg.textContent = "";
			vehicleList.parentNode.insertBefore(failToFitMsg, vehicleList);
		}
		if (!doesNotFit) {
			failToFitMsg.style.display = "none";
		} else {
			failToFitMsg.style.display = "block";
		}
	}
}

function toggleGaragePopup() {
	// Always select the popup regardless of hidden state
	let garageEasyPopup = document.querySelector(".garage-easyYMM-popup");
	if (!garageEasyPopup) {
		console.error("No .garage-easyYMM-popup element found!");
		return;
	}

	const garagePopupStyleId = "garage-popup-style";
	const scrollY = window.scrollY;

	garageEasyPopup.classList.toggle("hidden");

	// Opens garage
	if (!garageEasyPopup.classList.contains("hidden")) {
		document.body.dataset.scrollY = scrollY;

		if (!document.getElementById(garagePopupStyleId)) {
			const style = document.createElement("style");
			style.id = garagePopupStyleId;
			style.textContent = `
            body.no-scroll-garage-popup {
              position: fixed;
              top: -${scrollY}px;
              left: 0;
              width: 100%;
              height: 100%;
              overflow: hidden !important;
            }
          `;
			document.head.appendChild(style);
		}
		document.body.classList.add("no-scroll-garage-popup");
		hideShopifyChat();
	} else {
		// Closes garage
		const savedScrollY = parseInt(document.body.dataset.scrollY || "0", 10);
		delete document.body.dataset.scrollY;

		let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
		if (
			document.getElementById("add-vehicle-btn").style.display === "none" &&
			terms.length > 0
		) {
			const garagePopupContainer = document.querySelector(
				".garage-easyYMM-popup-container"
			);
			garagePopupContainer.querySelector(".easyYMM").style.display = "none";
			document.getElementById("vin-to-collection-placeholder").style.display =
				"none";
			document.getElementById("vin-to-collection-or").style.display = "none";
			if (garagePopupContainer) {
				garagePopupContainer.classList.remove("no-bottom-radius");
			}
			document.getElementById("add-vehicle-btn").style.display = "flex";
			document.querySelector(".garage-block").style.display = "block";
			document.querySelector(".select-your-vehicle-header").style.display =
				"none";
		}
		const style = document.getElementById(garagePopupStyleId);
		if (style) {
			style.remove();
		}

		window.scrollTo(0, savedScrollY);
		showShopifyChat();

		// Close edit car state if open
		if (window.editCarState) {
			window.editCarState.open = false;
		}
	}
}

function generateCollectionHandle(vehicleData) {
	let collectionHandle = vehicleData
		.toLowerCase()
		.replace(/[./]/g, "-")
		.replace(/\s+/g, "-")
		.replace(/[^\w\-]+/g, "")
		.replace(/--+/g, "-")
		.replace(/-+$/, "");

	return collectionHandle;
}

// Simplified showMismatchModal - now uses pre-validated data
function showMismatchModal(differences, vin, licensePlate, paintCode) {
	const modalContainer = document.querySelector(".mismatch-modal-container");
	const modalOverlay = document.querySelector(".mismatch-modal-overlay");
	const differencesContainer = document.getElementById("mismatch-details");

	if (!modalContainer || !modalOverlay || !differencesContainer) {
		console.error("Modal elements not found");
		return;
	}

	// Get validation results from global scope (set in normalizeModelAndCompare)
	const validationResult = window.EASYSEARCH_VALIDATION_RESULT || {
		canResolveYMM: false,
		canResolveComplete: false,
	};

	// Build comparison table
	const user = getSearchTerms()[0] || {};
	const decoded = decodedVehicleData || {};
	decoded.paintCode = paintCode;

	// If User selected from select Paint Code, update paintCode here
	const combinedVariantSelect = document.getElementById("variant-selector");
	const selectedOption =
		combinedVariantSelect.querySelector("option:checked") ||
		combinedVariantSelect.querySelector("option[selected]");
	let variantTitle = null;
	if (selectedOption) {
		variantTitle = selectedOption.getAttribute("data-variant-title");
		user.paintCode = variantTitle;
	}
	const FIELDS = [
		["year", "Year"],
		["make", "Make"],
		["model", "Model"],
		// ["submodel", "Submodel"],
		// ["engine", "Engine"],
		// ["paintCode", "PaintCode"], // could bring it back when needed
	];

	function fmt(v) {
		if (v == null) return "—";
		const s = String(v).trim();
		return s.length ? s : "—";
	}

	const toKey = (v) =>
		String(v ?? "")
			.toLowerCase()
			.trim();

	const rows = FIELDS.map(([key, label]) => {
		const u = key === "year" ? user.year ?? user.year?.toString() : user[key];
		const d =
			key === "year" ? decoded.year ?? decoded.year?.toString() : decoded[key];
		const isDiff = toKey(u) !== toKey(d);

		return `
            <tr>
                <th class="mismatch-field" style="font-weight: bold;">${label}</th>
                <td><span class="${
									isDiff ? "mismatch-diff" : "mismatch-same"
								}">${fmt(u)}</span></td>
                <td><span class="${
									isDiff ? "mismatch-diff" : "mismatch-same"
								}">${fmt(d)}</span></td>
            </tr>
        `;
	}).join("");

	const diffHTML = `
        <div>
            <table class="mismatch-table">
                <thead>
                    <tr>
                        <th></th>
                        <th style="font-weight: bold;">Your selection</th>
                        <th style="font-weight: bold;">Decoded</th>
                    </tr>
                </thead>
                <tbody>${rows}</tbody>
            </table>
        </div>
    `;

	differencesContainer.innerHTML = diffHTML;

	// remember which radio was selected before the mismatch modal opens
	const wasVinChecked = document.getElementById(
		"checkbox-get-paint-code-with-vin"
	)?.checked;
	const wasLicenseChecked = document.getElementById(
		"checkbox-get-paint-code-with-license"
	)?.checked;

	openQuestionModal({
		scrollLockClass: "no-scroll",
		overlaySelector: ".mismatch-modal-overlay",
		modalSelector: ".mismatch-modal-container",
	});
	// restore paint-option radio selection right after the modal opens
	const vinRadio = document.getElementById("checkbox-get-paint-code-with-vin");
	const licRadio = document.getElementById(
		"checkbox-get-paint-code-with-license"
	);
	if (vinRadio && wasVinChecked) vinRadio.checked = true;
	if (licRadio && wasLicenseChecked) licRadio.checked = true;
	if (typeof syncFakeCircle === "function") syncFakeCircle();
	// setup the calling location
	const isCallFromVinInput = vinRadio.checked === true ? true : false;
	const isCallFromSelectPaintCode =
		document.getElementById("checkbox-select-paint-option") &&
		document.getElementById("checkbox-select-paint-option").checked === true
			? true
			: false;
	// Setup buttons
	const closeBtn = document.getElementById("mismatch-back-btn");
	const proceedBtn = document.getElementById(
		"mismatch-close-and-use-decoded-btn"
	);

	closeBtn.replaceWith(closeBtn.cloneNode(true));
	proceedBtn.replaceWith(proceedBtn.cloneNode(true));

	const newCloseBtn = document.getElementById("mismatch-back-btn");
	const newProceedBtn = document.getElementById(
		"mismatch-close-and-use-decoded-btn"
	);

	// Check if major fields differ
	const biMisMatch = ["make", "model"].every(
		(k) => differences && differences[k]
	);
	// check if all three fields differ
	const triMisMatch = ["year", "make", "model"].every(
		(k) => differences && differences[k]
	);

	window.MISMATCH_ALL_THREE = !!triMisMatch;

	// Update button states based on pre-validated data
	updateButtonStates(
		newProceedBtn,
		newCloseBtn,
		biMisMatch,
		validationResult.canResolveYMM
	);

	// Setup event listeners
	setupModalEventListeners(
		newProceedBtn,
		newCloseBtn,
		vin,
		licensePlate,
		paintCode,
		biMisMatch,
		validationResult,
		isCallFromVinInput,
		isCallFromSelectPaintCode
	);
}

function updateButtonStates(proceedBtn, closeBtn, biMisMatch, canResolveYMM) {
	// Before resorting to match by vin, we must ensure that it exists in the first place
	const hiddenVinOption = document.querySelector(".hidden-vin-option");
	if (biMisMatch && !canResolveYMM) {
		proceedBtn.style.display = "none";
		proceedBtn.disabled = true;
		closeBtn.textContent = getAttr(
			closeBtn,
			"data-use-selection",
			"Go back and use your selection"
		);
	} else if (biMisMatch && canResolveYMM) {
		proceedBtn.style.display = "block";
		proceedBtn.disabled = false;
		proceedBtn.textContent = getAttr(
			proceedBtn,
			"data-use-decoded",
			"Continue with decoded vehicle"
		);
	} else if (!biMisMatch && !canResolveYMM && hiddenVinOption) {
		proceedBtn.style.display = "block";
		proceedBtn.disabled = false;
		proceedBtn.textContent = getAttr(
			proceedBtn,
			"data-use-match_paint_by_vin",
			"Continue with Match Paint by VIN"
		);
	} else {
		proceedBtn.style.display = "block";
		proceedBtn.disabled = false;
		proceedBtn.textContent = getAttr(
			proceedBtn,
			"data-use-decoded",
			"Continue with decoded vehicle"
		);
	}
}

function setupModalEventListeners(
	proceedBtn,
	closeBtn,
	vin,
	licensePlate,
	paintCode,
	biMisMatch,
	validationResult,
	isCallFromVinInput,
	isCallFromSelectPaintCode
) {
	proceedBtn.addEventListener("click", async (e) => {
		e.preventDefault();
		e.stopPropagation();

		if (biMisMatch && !validationResult.canResolveYMM) {
			console.warn("Cannot proceed: All fields differ and can't be resolved");
			return;
		}

		if (!validationResult.canResolveYMM) {
			// Use Match Paint by VIN flow
			handleMatchPaintByVinFlow(vin);
			closeMismatchModal();
			return;
		}

		// Proceed with decoded vehicle
		await handleDecodedVehicleFlow(vin, paintCode, validationResult);
	});

	closeBtn.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		closeMismatchModal();

		failedVinDecode = false;

		/// isCallFromVinInput is passed from main showMismatch function
		clearAndHidePaintOptionSelect(
			e,
			isCallFromVinInput,
			isCallFromSelectPaintCode
		);

		// If call is from select paint code, re-evaluate add to cart button state -- could either enable or disable
		// If call is from vin input, then must ensure the add to cart button is disabled
		if (isCallFromSelectPaintCode) {
			evaluateAddToCartButtonState();
		} else {
			const addToCartBtn = document.querySelector(".add-to-cart");
			if (addToCartBtn) addToCartBtn.disabled = true;
		}
	});
}

async function handleDecodedVehicleFlow(vin, paintCode, validationResult) {
	isMismatch = true;
	const newSubmodel = validationResult.submodel
		? validationResult.submodel
		: "";
	const newEngine =
		newSubmodel && validationResult.engine ? validationResult.engine : "";

	const newYmm = [
		validationResult.year.toString(),
		validationResult.make,
		validationResult.model,
		newSubmodel,
		newEngine,
	]
		.filter(Boolean)
		.join(" ");

	const terms = getSearchTerms();
	// check if the make is troublesome make
	if (troublesomeMakesGlobal.includes(validationResult.make.toLowerCase())) {
		paintCode = "";
	}
	updateSearchTerms(
		newYmm,
		validationResult.year.toString(),
		validationResult.make,
		validationResult.model,
		newSubmodel,
		newEngine,
		vin,
		paintCode,
		validationResult.decodedByBumper,
		terms[0]?.lastCollectionImage
	);

	const searchTerms = getSearchTerms();
	if (window.GarageLogic && window.GarageLogic.updateGaragePopup) {
		window.GarageLogic.updateGaragePopup(searchTerms);
	}

	// Update fitment and navigate
	if (searchTerms.length > 0) {
		const newFirstVehicle = searchTerms[0];
		const fields = [
			newFirstVehicle.year.toString(),
			newFirstVehicle.make,
			newFirstVehicle.model,
			newSubmodel,
			newEngine,
		];
		const fitmentValue = fields
			.filter((f) => f && f?.trim())
			.map((f) => f?.trim() + "easysearch-preselect-delimiter")
			.join("");
		const expires = Date.now() + 365 * 24 * 60 * 60 * 1000;
		setFitmentObject({
			value: fitmentValue,
			expires: expires.toString(),
		});
	}

	// Navigate to collection
	const partType = document
		.getElementById("product-title")
		?.getAttribute("product-type");
	const vehicle = generateCollectionHandle(searchTerms[0].ymm);

	let baseUrl =
		globalLocale === "en"
			? `/collections/${vehicle}?filter.p.product_type=${partType}`
			: `/es/collections/${vehicle}?filter.p.product_type=${partType}`;

	try {
		const response = await fetch(baseUrl);
		const html = await response.text();
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const productGrid = doc.querySelector(".productgrid--items");

		if (productGrid && productGrid.children.length > 0) {
			window.location.href = baseUrl;
		} else {
			baseUrl =
				globalLocale === "en"
					? `/collections/${vehicle}`
					: `/es/collections/${vehicle}`;
			window.location.href = baseUrl;
		}
	} catch (e) {
		console.error(e);
		alert("Could not check products. Please try again.");
	}

	isMismatch = false;
}

function handleMatchPaintByVinFlow(vin) {
	window.MISMATCH_UNRESOLVED = true;

	const terms = getSearchTerms();
	if (terms.length) {
		const t0 = terms[0];
		t0.vin = t0.vin && t0.vin.length === 17 ? t0.vin : vin || "";
		setSearchTerms(terms);
		window.GarageLogic.updateGaragePopup(getSearchTerms());
	}

	const matchPaintByVinPrice = handleAppendMatchByVin(vin, true);
	handleAutoSelectMatchByVin();

	const localPaintCodeAppContainer = document.getElementById(
		"paintcode-app-container"
	);
	if (localPaintCodeAppContainer?.classList.contains("show")) {
		localPaintCodeAppContainer.classList.remove("show");
	}

	if (!matchPaintByVinPrice) {
		resortToForceSelectCode();
	} else {
		matchingPaintByVinVisible = true;
		storedOptionLabel.style.display = "block";
		const checkboxUseStoredCode = document.getElementById(
			"checkbox-paint-code-local-storage"
		);
		checkboxUseStoredCode.checked = true;
		checkboxStoredCodeText.innerHTML =
			matchPaintByVinTranslationKey + " +" + matchPaintByVinPrice;

		const paintCodeWrapperGlobal = document.querySelector(
			".paint-code-wrapper"
		);
		if (paintCodeWrapperGlobal?.classList.contains("show")) {
			paintCodeWrapperGlobal.classList.remove("show");
		}

		// const vinSubmitBtn = document.querySelector(".vin-decoder-submit-btn");
		const vinSubmitBtn = document.querySelector(
			'.vin-decoder-submit-btn:not([style*="display: none"])'
		);
		if (vinSubmitBtn) vinSubmitBtn.disabled = true;

		const paintOptionsVinLicense = document.querySelector(
			".paint-options-vin-license"
		);
		if (paintOptionsVinLicense) paintOptionsVinLicense.style.display = "none";

		// const vinWrapper = document.getElementById(
		// 	"vin-decoder-textbox-for-verification-wrapper-byvin"
		// );
		const vinWrapper = document.querySelector(
			'[id^="vin-decoder-textbox-for-verification-wrapper"]:not([style*="display: none"])'
		);
		if (vinWrapper) vinWrapper.style.display = "none";
	}
}

function closeMismatchModal() {
	closeQuestionModal(
		"no-scroll",
		window.scrollY,
		".mismatch-modal-container",
		".mismatch-modal-content",
		".mismatch-modal-overlay"
	);
	isMismatch = false;
}

function getAttr(node, name, fallback = "") {
	return node?.getAttribute(name) || fallback;
}

async function checkAndNavigate(url, alterUrl) {
	try {
		const response = await fetch(url, {
			method: "HEAD", // Use HEAD to only request headers, saving bandwidth
		});

		if (response.ok) {
			// Check if the status code is 200-299
			window.location.href = url; // Page exists, navigate the user
		} else {
			console.error(`Page returned status: ${response.status}`);
			window.location.href = alterUrl; // Page not found (404, 500, etc.), redirect to fallback
		}
	} catch (error) {
		// This catches network errors (e.g., DNS failure, server offline)
		console.error("Network or Fetch error:", error);
		window.location.href = "/";
	}
}

// add once (tiny promise cache)
let __vinLookupCache, __vinLookupLoading;
function loadVinLookup() {
	if (__vinLookupCache) return Promise.resolve(__vinLookupCache);
	if (!__vinLookupLoading) {
		const url = window.VIN_LOOKUP_URL || "/assets/vinLookupToAces.json";
		__vinLookupLoading = fetch(url)
			.then((r) => {
				if (!r.ok) throw new Error(r.status);
				return r.json();
			})
			.then((json) => (__vinLookupCache = json))
			.finally(() => {
				__vinLookupLoading = null;
			});
	}
	return __vinLookupLoading;
}

// add once for submodel comparison
let __submodelMapCache, __submodelMapLoading;
function loadSubmodelMap() {
	if (__submodelMapCache) return Promise.resolve(__submodelMapCache);
	if (!__submodelMapLoading) {
		const url =
			window.SUBMODEL_MAP_URL || "/assets/subaruForesterSubmodelScrape.json";
		__submodelMapLoading = fetch(url)
			.then((r) => {
				if (!r.ok) throw new Error(r.status);
				return r.json();
			})
			.then((json) => (__submodelMapCache = json))
			.finally(() => {
				__submodelMapLoading = null;
			});
	}
	return __submodelMapLoading;
}

// Helper function to normalize and validate against EasySearch

async function validateAndNormalizeVehicleData(decodedData) {
	const { year, make, model, submodel, engine } = decodedData;

	let resolvedFields = {
		year: null,
		make: null,
		model: null,
		submodel: null,
		engine: null,
		canResolveYMM: false,
		canResolveComplete: false,
	};

	//Validdate each field
	try {
		// **IMPORTANT**: Wait for each select sequentially since they're hierarchical
		resolvedFields.year = await setSelectValueWhenReady(
			"easysearch_field_4973",
			(year || "").toString(),
			4000
		);

		if (!resolvedFields.year) {
			console.warn("Cannot resolve decoded year in EasySearch");
			return resolvedFields;
		}

		// Wait for make dropdown to populate after year selection
		await new Promise((resolve) => setTimeout(resolve, 50));
		resolvedFields.make = await setSelectValueWhenReady(
			"easysearch_field_4974",
			make || "",
			3000
		);

		if (!resolvedFields.make) {
			console.warn("Cannot resolve decoded make in EasySearch");
			return resolvedFields;
		}

		// Step 3: Try to resolve Model using vinLookup if direct match fails
		await new Promise((resolve) => setTimeout(resolve, 50));
		let normalizedModel = model;

		// First try direct match
		// Wait for model dropdown to populate after make selection
		let modelVal = await setSelectValueWhenReady(
			"easysearch_field_4975",
			model || "",
			3000
		);

		// If direct match fails, try vinLookup
		if (!modelVal) {
			try {
				const vinLookupData = await loadVinLookup();
				const hit = vinLookupData.find((x) => {
					return (
						String(x.Model || "")
							.toLowerCase()
							.replace(/[^a-z0-9]/g, "")
							.trim() ===
						String(model)
							.toLowerCase()
							.replace(/[^a-z0-9]/g, "")
							.trim()
					);
				});
				if (hit && hit["Easysearch Model"]) {
					normalizedModel = hit["Easysearch Model"];
					modelVal = await setSelectValueWhenReady(
						"easysearch_field_4975",
						normalizedModel,
						3000
					);
				}
			} catch (error) {
				console.error(error);
				console.warn("VIN lookup failed for model:", e);
			}
		}
		resolvedFields.model = modelVal;

		if (!resolvedFields.model) {
			console.warn("Cannot resolve decoded model in EasySearch");
			window.MISMATCH_JSON_LOOKUP_MISS = true;
			return resolvedFields;
		}
		// At this point, Y/M/M resolved successfully
		resolvedFields.canResolveYMM = true;

		// Now try submodel and engine (optional fields)
		// Step 4: Try to resolve Submodel using submodelMap
		await new Promise((resolve) => setTimeout(resolve, 50));
		let normalizedSubmodel = submodel;

		if (submodel) {
			// Try direct match first
			let submodelVal = await setSelectValueWhenReady(
				"easysearch_field_28136",
				submodel || "",
				800
			);

			// If direct match fails, try submodelLoopup
			if (!submodelVal && make && model && year) {
				try {
					const submodelMap = await loadSubmodelMap();
					// navigat to Make -> model -> decoded submodel
					const makeData = submodelMap[make];

					if (makeData && makeData[normalizedModel]) {
						const modelData = makeData[normalizedModel];

						//Check if the decoded submodel exists as a key in JSON
						if (modelData[submodel]) {
							// get easysearch submodel
							const easysearchSubmodels =
								modelData[submodel][0]?.Easysearch?.Submodel || [];
							if (easysearchSubmodels.length > 0) {
								normalizedSubmodel = easysearchSubmodels[0];
								// try to set it in easysearch
								submodelVal = await setSelectValueWhenReady(
									"easysearch_field_28136",
									normalizedSubmodel,
									800
								);
								console.log(
									`Submodel mapped: "${submodel}" -> "${normalizedSubmodel}"`
								);
							}
						}
					}
				} catch (error) {
					console.warn("Submodel map lookup failed:", e);
				}
			}
			resolvedFields.submodel = submodelVal;
			console.log("Final submodel resolution:", resolvedFields.submodel);
		}

		// try to resolve engine
		await new Promise((resolve) => setTimeout(resolve, 50));
		if (engine) {
			resolvedFields.engine = await setSelectValueWhenReady(
				"easysearch_field_28137",
				engine || "",
				500
			);
		}

		// Determine if complete vehicle is resolved
		resolvedFields.canResolveComplete = !!(
			resolvedFields.submodel && resolvedFields.engine
		);

		console.log("Vehicle validation complete:", resolvedFields);

		// Rollback selections to avoid side effects
		await setSelectValueWhenReady("easysearch_field_4973", "");
		await setSelectValueWhenReady("easysearch_field_4974", "");
		await setSelectValueWhenReady("easysearch_field_4975", "");
		await setSelectValueWhenReady("easysearch_field_28136", "");
		await setSelectValueWhenReady("easysearch_field_28137", "");

		return resolvedFields;
	} catch (error) {
		console.error("Error validating vehicle data:", error);
		return resolvedFields;
	}
}

function openQuestionModal({
	scrollLockClass = "no-scroll-paint-swatch",
	accordionSelector = ".accordion-section",
	overlaySelector = ".product-unfolded-popup-dark-overlay",
	modalSelector = ".unfolded-popup-container",
	modalContentSelector = ".popup-modal-content",
	fetchContentFn = null, // async function to fetch content, if needed
}) {
	// Save scroll position globally
	// window.paintModalScrollPosition = window.scrollY || document.documentElement.scrollTop;

	// Optionally expand accordions
	if (accordionSelector) {
		const accordionSections = document.querySelectorAll(accordionSelector);
		accordionSections.forEach((section) => {
			const content = section.querySelector(".accordion-content");
			const circlePlus = section.querySelector(".circle_plus");
			const circleNone = section.querySelector(".circle_none");
			const isOpen = content.classList.contains("open");
			requestAnimationFrame(() => {
				setTimeout(() => {
					if (!isOpen) {
						content.classList.add("open");
						content.style.maxHeight = content.scrollHeight + "px";
						if (circlePlus) circlePlus.style.display = "none";
						if (circleNone) circleNone.style.display = "block";
					}
				}, 500);
			});
		});
	}

	// Lock scroll
	document.body.classList.add(scrollLockClass);

	// Hide Shopify chat
	if (typeof hideShopifyChat === "function") hideShopifyChat();

	// Show overlay
	if (overlaySelector) {
		const overlay = document.querySelector(overlaySelector);
		if (overlay) overlay.style.display = "block";
	}

	// Show modal and set content
	if (modalSelector) {
		document.querySelector(modalSelector).style.display = "block";
	}
	if (fetchContentFn && modalContentSelector) {
		const result = fetchContentFn();
		if (result && typeof result.then === "function") {
			// If fetchContentFn returns a Promise
			result
				.then((pageContent) => {
					document.querySelector(modalContentSelector).innerHTML = pageContent;
				})
				.catch((error) => {
					console.error("Error fetching modal content:", error);
				});
		}
		// If fetchContentFn is synchronous, it already handled the content
	}
}

function showQuestionModal(
	content,
	showContent,
	modalElement,
	containerElement
) {
	const modalContent = document.querySelector(modalElement);
	if (showContent) {
		modalContent.innerHTML = content;
	}
	document.querySelector(containerElement).style.display = "block";
}

function closeQuestionModal(
	noScrollElement,
	scrollPosition,
	containerElement,
	modalElement,
	overlayElement
) {
	// Remove scroll lock and restore scroll position
	document.body.classList.remove(noScrollElement);
	window.scrollTo(0, scrollPosition); // Restore scroll position

	// Show Shopify chat and hide overlay
	if (!isMismatch) {
		showShopifyChat();
	}
	hideQuestionModalOverlay(overlayElement);
	hideQuestionModal(containerElement, modalElement);
}

function hideQuestionModal(containerElement, modalElement) {
	const container = document.querySelector(containerElement);
	const modal = document.querySelector(modalElement);
	const onAnimationEnd = function () {
		modal.style.animation = "";
		container.style.display = "none";
		modal.removeEventListener("animationend", onAnimationEnd);
	};

	modal.style.animation = "drop-out 0s forwards";
	modal.addEventListener("animationend", onAnimationEnd);
}

function hideQuestionModalOverlay(overlayElement) {
	document.querySelector(overlayElement).style.display = "none";
}

function showQuestionModalOverlay(overlayElement) {
	document.querySelector(overlayElement).style.display = "block";
}

function accordionButtonHandle(button, section) {
	const accordionSection = button.closest(section);
	const content = accordionSection.querySelector(".accordion-content");
	const circlePlus = accordionSection.querySelector(".circle_plus");
	const circleNone = accordionSection.querySelector(".circle_none");

	// Check if the clicked accordion is already open
	const isOpen = content.classList.contains("open");

	if (isOpen) {
		// Open the clicked accordion
		content.classList.remove("open");
		content.style.maxHeight = 0;

		// Show the minus icon and hide the plus icon for the active accordion
		circlePlus.style.display = "block";
		circleNone.style.display = "none";
	}

	if (!isOpen) {
		// Open the clicked accordion
		content.classList.add("open");
		content.style.maxHeight = content.scrollHeight + "px";

		// Show the minus icon and hide the plus icon for the active accordion
		circlePlus.style.display = "none";
		circleNone.style.display = "block";
	}
}

function hideShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "none";
	}
}

// Function to show Shopify chat widget
function showShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "block";
	}
}

function pushLicenseToCart() {
	const terms = window.getSearchTerms?.();
	if (!terms || !terms.length) {
		console.warn("No search terms found. Plate/State not added to cart.");
		return;
	}

	const { plate, state } = terms[0]; // always use the first one
	const forms = document.querySelectorAll('form[action^="/cart/add"]');
	if (!forms.length) {
		console.warn("No add-to-cart forms found. Plate/State not attached.");
		return;
	}

	forms.forEach((form) => {
		// Hidden Plate field
		let plateField = form.querySelector('input[name="properties[Plate]"]');
		if (!plateField) {
			plateField = document.createElement("input");
			plateField.type = "hidden";
			plateField.name = "properties[Plate]";
			form.appendChild(plateField);
		}

		// Hidden State field
		let stateField = form.querySelector('input[name="properties[State]"]');
		if (!stateField) {
			stateField = document.createElement("input");
			stateField.type = "hidden";
			stateField.name = "properties[State]";
			form.appendChild(stateField);
		}

		// Sync right before submit
		form.addEventListener(
			"submit",
			(e) => {
				plateField.value = (plate || "").trim().toUpperCase();
				stateField.value = (state || "").trim().toUpperCase();

				// disable duplicates if any exist
				[plateField, stateField].forEach((field) => {
					form.querySelectorAll(`input[name="${field.name}"]`).forEach((el) => {
						if (el !== field) el.disabled = true;
					});
				});
			},
			{ capture: true }
		);
	});
}

// Helper function to find available instance
function getVisibleVinDecoderElements() {
	// Find all wrappers
	const wrappers = document.querySelectorAll(
		'[id^="vin-decoder-textbox-for-verification-wrapper-"]'
	);
	// Find the visible one
	for (const wrapper of wrappers) {
		// Check if wrapper has 'show' class AND is actually visible in DOM
		if (wrapper.classList.contains("show") && wrapper.offsetParent !== null) {
			return {
				wrapper: wrapper,
				input: wrapper.querySelector(
					'[id^="vin-decoder-textbox-for-verification-"]'
				),
				submitBtn: wrapper.querySelector(".vin-decoder-submit-btn"),
				validationError: wrapper.querySelector(".vin-validation-error"),
				vinAfterSelection: wrapper.querySelector(
					'[id^="vin-after-paint-code-selection-"]'
				),
				vinInputContainer: wrapper.querySelector(
					".vin-input-label-and-textbox"
				),
			};
		}
	}

	return null;
}
